<template>
	<div class="page-accounting-action" v-if="verifySubsidiary">
		<header-page
			actions
			name="page-batch-accounting"
			:title="$route.meta.title"
			@run-action="runAction"
			:button-close="openMobile"
			tabindex="-1"
			@click-close="closeMobile"
		/>
		<action-bar
				:value-disabled="valuesDisabled"
				class="action-mobile"
				:resource-uri="$route.name"
				@run-action="runAction"
		></action-bar>
		<v-dialog
			content-class="dialog-loading"
			max-width="300"
			persistent
			v-model="dialogLoading"
		>
			<label class="loading-search">
				Espere unos segundos por favor
			</label>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
		</v-dialog>
		<div class="pt-3 px-4 show-mobile">
			<v-layout row align-center wrap>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						class="select-accouting"
						label="Módulos"
						item-text="name"
						item-value="code"
						:height="32"
						v-model="model.moduleId"
						:items="modulesFilter"
						:value="model.moduleId"
						@input="setModule"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2 v-if="this.model.moduleId === 'VENTA'">
					<BaseSelect
						class="select-accouting"
						label="Tipo de Factura"
						clear
						item-text="name"
						item-value="id"
						:height="32"
						v-model="model.typeFac"
						:items="statusFacs"
						:value="model.typeFac"
						@input="setStatusFac"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Estado de registros"
						item-text="name"
						item-value="id"
						:height="32"
						v-model="model.accountingSeat"
						:items="statusRecords"
						:value="model.accountingSeat"
						@input="setStatusRecords"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						class="select-accouting"
						item-text="name"
						item-value="id"
						label="Fechas"
						:height="32"
						:items="typesDate"
						@input="getDataDate($event)"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
					<span class="captionDate">Fecha Desde</span>
					<date-component
						round
						:date="model.startDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'startDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
					<span class="captionDate">Fecha hasta</span>
					<date-component
						round
						:date="model.endDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'endDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs3 sm9 lg2 xs12>
					<v-layout row>
						<v-flex ml-3>
							<v-btn
								:disabled="!model.moduleId || flagStateRecord || loading"
								color="blue"
								class="ma-0 btn-accounting mt-3"
								@click="loadCont"
							>
								Buscar
							</v-btn>
						</v-flex>
						<v-flex ml-2>
							<v-btn
								color="error"
								class="ma-0 mt-3 btn-accounting"
								@click="clearAccouting"
							>
								Limpiar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 v-if="showAccouting">
					<v-btn
						:disabled="openMobile"
						color="blue"
						class="ma-0 btn-accounting mt-3 desktop"
						@click="openMobileAccouting"
					>
						Ver Asientos Contable
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout row justify-end wrap>
				<v-flex xs2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Estado de asientos"
						item-text="name"
						item-value="id"
						:height="38"
						v-model="model.status"
						:items="status"
						:value="model.status"
						@input="setStatus"
					/>
				</v-flex>
				<v-flex xs2 sm2 md2 px-2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Tipo de Asientos"
						item-text="name"
						item-value="id"
						:height="38"
						v-model="model.square"
						:items="typesModule"
						:value="model.square"
						@input="setTypes"
					/>
				</v-flex>
				<v-flex xs3 sm2 md2 px-2 pt-2>
					<v-btn
						:disabled="disabledConfirm || flagNoConfirm || flagStatusAccounting || (model.status === 3 && model.square === 2)"
						color="#2196f3"
						class="btnSaveAccounting"
						@click="saveAccouting"
					>
						Confirmar Asiento
						<v-icon dark>
							check_circle
						</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
		<div class="row-mobile">
			<v-layout row wrap mt-4>
				<v-flex xs12 sm12 lg6 px-2 v-if="listAccounting && !openMobile">
					<app-table
	:check-all="checkAll"
	:columns="columns"
	:rows="rows"
	flag-title
	:items-total-quantity="itemsTotalQuantity || rows.length"
	:items-quantity="rows.length"
	:last-page="lastPage"
	:title="titleModule"
	:input-search="false"
	:current-page="currentPage"
	:created-add="false"
	selectable
	@on-search-event="onSearch"
	@row-is-selected="rowIsSelected"
	@on-selected-all="selectedAll"
	@on-page="changePage"
>
	<template slot="rows" slot-scope="props">
		<!-- Aplicar el color a cada celda (td) -->
		<td
			style="height: 50px; font-size: 13px; width: 105px;"
			v-show="showRow(columns, 1)"
			v-html="validateDateRow(props.row)"
		>
		</td>
		<td
			style="height: 50px; font-size: 13px;"
			v-show="showRow(columns, 2)"
			class="entity"
		>
			<p class="mb-0">
				<span class="desktop">Numero de documento: </span>
				<span v-if="props.row.documentNumberComplete && !mobile">
					<span v-if="props.row.documentNumberComplete && props.row.documentNumberComplete.length < 17">{{
						props.row.transactionId ||
							props.row.documentNumberComplete ||
							props.row.documentAccountStatusId ||
							props.row.code ||
							props.row.gloss ||
							props.row.documentNumber
					}}</span>
					<v-tooltip top v-else>
						<span slot="activator">{{
							props.row.id ||
								props.row.documentNumberComplete ||
								props.row.documentAccountStatusId ||
								props.row.code ||
								props.row.gloss ||
								props.row.documentNumber
						}}</span>
						<span>{{
							props.row.transactionId ||
								props.row.documentNumberComplete ||
								props.row.documentAccountStatusId ||
								props.row.code ||
								props.row.gloss ||
								props.row.documentNumber
						}}</span>
					</v-tooltip>
				</span>
				<span v-else>
					{{
						props.row.documentNumberComplete ||
							props.row.documentAccountStatusId ||
							props.row.code ||
							props.row.gloss ||
							props.row.documentNumber ||
							props.row.id
					}}
				</span>
			</p>
		</td>
		<td
			style="height: 50px; font-size: 13px;"
			v-show="showRow(columns, 3)"
		>
			{{
				props.row.documents && props.row.documents != null
					? props.row.documents.toString()
					: props.row.observations ||
					props.row.documentNumber ||
					props.row.sendKardexMessage ||
					props.row.gloss ||
					props.row.description
			}}
		</td>

		<td v-show="showRow(columns, 4)" style="display: grid; place-items: center; height: 50px; width: 90px;">
	<div
		class="tooltip-container"
		:style="{ backgroundColor: props.row.color }"
	>
		<div class="tooltip-content">
			{{ props.row.moduleCode }}
		</div>
	</div>
</td>

	<td
  style="height: 50px; text-align: center; vertical-align: middle; font-size: 13px; font-weight: bold;"
  :style="{ color: (!props.row.amount) ? 'red' : '#02979b' }"
  v-show="showRow(columns, 5)"
>
  <v-flex
    :data-tooltip="props.row.amount ? `EL VALOR DEL REGISTRO ES: ${(props.row.amount).toFixed(2)}` : 'ES UN REGISTRO CON VALOR 0'"
    :class="{ 'tooltip-zero': !props.row.amount }"
    style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; font-size: 13px; font-weight: bold;"
    :style="{ color: (!props.row.amount) ? 'red' : '#02979b' }"
  >
    {{ props.row.amount ? props.row.amount.toFixed(2) : ' 0.00' }}
  </v-flex>
</td>
	<td
>
<app-tooltip-button
									color="#1fd9b6"
									icon="remove_red_eye"
									text="Ver Información"
									:width="17"
									@click-icon="openDetailRegister(props.row)"
								/>
</td>
	</template>
</app-table>
				</v-flex>
				<v-flex
					xs12
					sm12
					lg6
					px-2
					class="content-acc"
					:class="{ open: openMobile }"
				>
					<app-table
						:created-add="false"
						:check-all="checkAllAccounting"
						:columns="columnsSeat"
						:rows="rowsSeat"
						:items-total-quantity="itemsTotalQuantityDetails"
						:items-quantity="rowsSeat.length"
						selectable
						:delete-seat="canDelete"
						:tooltip-delete="deleteTooltip"
						show-accounting
						flag-title
						:title="titleModuleSeat"
						:current-page="currentPageDetail"
						:input-search="false"
						:disabled-edit-accou="!rowsSeat.length > 0"
						:show-table-accounting="showDetailAccounting"
						:rows-details="rowsDetails"
						:last-page="lastPageDetails"
						@delete-seat="runAction('delete-seat')"
						@on-selected-all="selectedAllSeat"
						@on-page="onPage"
						@row-is-selected="rowIsSelectedAccounting"
						@edit-accouting="goToEditAccouting"
					>
						<template slot="rows" slot-scope="props">
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 1)"
							>
								{{ props.row.code }}
							</td>
							<td v-show="showRow(columnsSeat, 2)" style="display: grid; place-items: center; height: 50px; width: 90px;">
								<div
									class="tooltip-container"
									:style="{ backgroundColor: props.row.color }"
								>
									<div class="tooltip-content">
										{{ props.row.moduleCode }}
									</div>
								</div>
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 3)"
								class="gloss"
							>
								<p class="mb-0">
									<span class="desktop">Descripción:</span>
									<span v-if="props.row.gloss && !mobile">
										<span v-if="props.row.gloss.length < 17">{{
											props.row.gloss
										}}</span>
										<v-tooltip top v-else>
											<span slot="activator">{{
												props.row.gloss | limitTo(17)
											}}</span>
											<span>{{ props.row.gloss }}</span>
										</v-tooltip>
									</span>
									<span v-else>
										{{ props.row.gloss }}
									</span>
								</p>
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 4)"
							>
								{{ props.row.date | exactDate }}
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 5)"
							>
								<app-tooltip-button
									:color="statusColor(props.row)"
									icon="radio_button_checked"
									:text="statusName(props.row)"
								/>
							</td>
							<td
								style="text-align: right; height: 50px; font-size: 11px;"
								v-show="showRow(columnsSeat, 6)"
								class="blue-debe"
							>
								{{  props.row.totalDebe | formatAmount }}
							</td>
							<td
								style="text-align: right; height: 50px; font-size: 11px;"
								v-show="showRow(columnsSeat, 7)"
								class="red-haber"
							>
								{{ props.row.totalHaber | formatAmount }}
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 8)"
							>
								<app-tooltip-button
									color="blue"
									icon="remove_red_eye"
									text="Ver Detalle"
									:width="17"
									@click-icon="openDetail(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
			<!-- Modal para mostrar los detalles de los asientos -->
			<v-dialog v-model="dialogDetailAccounting" max-width="950">
				<v-card>
					<v-layout pa-3>
						<v-flex>{{ nameAccouting }}</v-flex>
						<v-flex text-xs-right>
							<close-icon class="cursor-pointer" @click="closeDialog"></close-icon>
						</v-flex>
					</v-layout>
					<v-divider></v-divider>
					<v-layout wrap v-if="openDetailSeat">
						<v-flex xs12 class="title-heading pt-1">
							Detalles
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-start>
								<v-flex xs8>
									<v-layout row wrap align-end>
										<v-flex xs12 pr-2 pt-1>
											<multiselect
												v-model="accountingAccountItem"
												:options="accounts"
												label="fullName"
												track-by="id"
												class="filter-select-custom"
												:select-label="''"
												:limit="100"
												:selected-label="''"
												:deselect-label="''"
												placeholder="Seleccione una cuenta"
												@select="setData">
												<template slot="option" slot-scope="props">
													<div
														:class="{
															'item-list-disabled': settings && settings
															.stat && props.option.stat === 1 }">
														{{ props.option.fullName }}
													</div>
												</template>
											</multiselect>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs4 pl-2>
									<app-input-text
										model="reference"
										placeholder="Referencia"
										:text="modelDetail.reference"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4 pr-2>
									<app-input-text
										model="concept"
										placeholder="Concepto"
										:text="modelDetail.concept"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4>
									<autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										:item="modelDetail.costCenterId"
										item-text="name"
										item-value="id"
										:items="costCenters"
										model="costCenterId"
										placeholder-value="Centro de costos"
										prop="name"
										autocomplete
										prop-search="name"
										:disabled="validCostCenter"
										:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
										return-object
										select-create
										@return-data="setCostCenter"
									></autocomplete-component>
								</v-flex>
								<v-flex xs3 pl-2>
									<app-input-text
										model="amount"
										placeholder="Importe"
										:text="modelDetail.amount"
										tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
										tooltip-on-focused
										type="number"
										@input="setModelData"
									></app-input-text>
									<span
										v-if="modelDetail.amount !== 0"
										:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
										Detalle de tipo {{ typeDetail }}
									</span>
								</v-flex>
								<v-flex xs1 text-xs-center pt-2>
									<v-tooltip top>
										<button
											class="btn-create-seat"
											slot="activator"
											type="button"
											:disabled="validFields || validInsertCostCenter"
											@click="saveNewDetailSeat"
										>
											<v-icon color="secondary" size="26">add_circle</v-icon>
										</button>
										<span v-if="validFields">Completar todos los campos</span>
										<span v-else-if="validInsertCostCenter">Debe escoger un centro de costo</span>
										<span v-else>Agregar</span>
									</v-tooltip>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<div class="pa-3">
						<app-table
							:rows="rowsDetailModal"
							:columns="columnsDetail"
							:input-search="false"
							:created-add="false"
							:t-foot="false"
							:main-list="false"
						>
							<template slot="rows" slot-scope="props">
								<td v-show="showRow(columnsDetail, 1)" 	class="is-not-selectable account">
									<template v-if="props.row.edit && props.row.flagEdit !== 0">
										<multiselect
											v-model="props.row.accountingAccount"
											:options="accounts"
											id="focus-edit-inline"
											label="fullName"
											track-by="id"
											class="filter-select-custom"
											:select-label="''"
											:limit="100"
											:selected-label="''"
											:deselect-label="''"
											placeholder="Seleccione una cuenta"
											tabindex="1"
											@select="changeAccount({
												row: props.row,
												value: $event,
												index: props.index,
											})">
											<template slot="option" slot-scope="props">
												<div
													:class="{
														'item-list-disabled': settings && settings
														.stat && props.option.stat === 1 }">
													{{ props.option.fullName }}
												</div>
											</template>
										</multiselect>
									</template>
									<template v-else>
										<div>
											<span>{{ props.row.accountingAccount.account }}</span>
										</div>
									</template>
								</td>
								<td v-show="showRow(columnsDetail, 2)">
									{{
										props.row.accountingAccount
											? props.row.accountingAccount.name
											: null
									}}
								</td>
								<td v-show="showRow(columnsDetail, 3)" class="reference">
									<p class="mb-0">
										<span class="desktop"
											>Referencia: {{ props.row.reference }}</span
										>
										<span v-if="props.row.reference && !mobile">
											<span>{{ props.row.reference }}</span>
										</span>
									</p>
								</td>
								<td v-show="showRow(columnsDetail, 4)">
									{{ props.row.concept }}
								</td>
								<td v-show="showRow(columnsDetail, 5)">
									{{ getType(props.row) }}
								</td>
								<td v-show="showRow(columnsDetail, 6)" v-if="props.row.edit && props.row.flagEdit !== 0">
									<app-input-text
										class="edit-inline"
										model="amountSeat"
										:text="props.row.amount | round"
										:value="props.row.amount | round"
										@change="
											changeAmountSeat({
												row: props.row,
												value: $event,
												index: props.index,
											})
										"
									></app-input-text>
								</td>
								<td style="text-align: end; padding: 0 5px" v-show="showRow(columnsDetail, 6)" v-else>
									{{ props.row.amount ? props.row.amount : 0 | formatAmount }}
								</td>
								<td v-show="showRow(columnsDetail, 7)">
									<template v-if="props.row.edit">
										<autocomplete-component
											append-icon="expand_more"
											class="edit-inline"
											http-code="$http"
											id="focus-edit-inline"
											:item="props.row.costCenter"
											item-text="name"
											item-value="id"
											:items="costCenters"
											autocomplete
											model="costCenter"
											placeholder-value="Buscar centro de costos"
											placeholder-input="Nombre del centro de costos"
											prop="name"
											prop-search="name"
											return-object
											select-create
											tabindex="1"
											@return-data="changeCostCenter({
												row: props.row,
												value: $event,
												index: props.index,
											})"
										></autocomplete-component>
										<span v-if="flagValidNumberAccount" class="msg-error">Debe seleccionar un centro de costo</span>
									</template>
									<template v-else>
										<div>
											<span>{{ props.row.costCenter && props.row.costCenter.name ? props.row.costCenter.name : null }}</span>
										</div>
									</template>
								</td>
								<td v-show="showRow(columnsDetail, 8)">
									<v-layout>
									<app-tooltip-button
										v-if="canEdit"
										color="success"
										:disabled="model.status === 2 || periodLock"
										img="/static/img/actions-list/edit.svg"
										:text="model.status === 1 ? 'Deshabilitado' : 'Editar'"
										:width="16"
										@click-icon="editSeats(props.row, props.index)"
									/>
									<app-tooltip-button
											v-if="props.row.flagEdit === 1 && canDelete"
											color="error"
											:disabled="model.status === 1 || periodLock"
											img="/static/img/actions-list/delete.svg"
											:text="model.status === 1 ? 'Deshabilitado' : 'Eliminar'"
											:width="16"
											@click-icon="deleteSeat(props.row, props.index)"
										/>
									</v-layout>
								</td>
							</template>
							<span
								v-if="dataSeat.code"
								slot="text"
								class="wrapper-text"
							>
								<v-tooltip top v-if="!periodLock && canCreate">
									<v-btn
										slot="activator"
										color="#33cfc7"
										class="btn-auto pa-0 ma-0 btn-add no-movil border-radius"
										type="button"
										@click="onAddDetail"
										>
										<v-icon color="white" size="19">add</v-icon>
									</v-btn>
									<span>Nuevo Detalle (ctrl + alt + k)</span>
								</v-tooltip>
							</span>
						</app-table>
					</div>
					<v-divider></v-divider>
					<v-card-actions>
						<div class="btn-actions">
							<v-tooltip top>
								<button
									slot="activator"
									class="btn-seat btn-save"
									:disabled="isLoading || squareAmounts || flagValidNumberAccount || validateSomeForceInsertCenterCost || validSquareAmounts || (!canEdit && !canCreate)"
									type="button"
									@click="saveAllDetailsEdits"
								>
									Guardar
								</button>
								<span v-if="squareAmounts">Debe cuadrar el asiento para guardar</span>
								<span v-else>Guardar</span>
							</v-tooltip>
							<button
								class="btn-seat btn-clean"
								type="button"
								@click="closeDialog"
							>
								Cancelar
							</button>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogAction" max-width="400">
				<v-card>
					<v-card-text class="title text-xs-center pt-4"
						>¿ Desea contabilizar los registros ?</v-card-text
					>
					<v-card-text class="titleNumberSeat text-xs-center pt-1"
						>Nº de Asientos a contabilizar:
						{{
							this.dataSelected.length === 0 ? 1 : this.dataSelected.length
						}}</v-card-text
					>
					<v-card-actions class="justify-center pb-4">
						<v-btn
							@click="closeDialogAction"
							type="button"
							color="error"
							class="btn-action mr-1 white--text"
						>
							NO
						</v-btn>
						<v-btn
							@click="postRecord"
							type="button"
							color="success"
							class="btn-action ml-1 white--text"
						>
							SI
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogWait" max-width="400" persistent>
				<v-card class="text-card">
					<v-card-text>
						<div class="loading-icon">
							<div class="spinner"></div>
							<p class="title text-xs-center pt-4">
								Espere un momento, se estan creando los asientos.
							</p>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				content-class="confirmation-dialog"
				v-model="cancelModal"
				max-width="400"
			>
				<v-card class="pa-4">
					<v-card-text class="title text-xs-center pt-4"
						>¿Desea eliminar los asientos seleccionados?</v-card-text
					>
					<v-card-actions class="justify-center pb-4">
						<button
							:disabled="flagWait"
							type="button"
							class="btn-modal cancelSeat mr-2"
							@click="setId"
						>
							No
						</button>
						<button
							:disabled="flagWait"
							type="button"
							class="btn-modal save ml-2"
							@click="onDeleteSeat"
						>
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				content-class="confirmation-dialog"
				v-model="dialogDeleteAccounting"
				max-width="400"
			>
				<v-card>
					<v-card-text class="title text-xs-center pt-4">{{
						titleDialogDelete
					}}</v-card-text>
					<v-card-actions class="justify-center pb-4">
						<button
							type="button"
							class="btn cancel"
							@click="closeDialogAccouting"
						>
							No
						</button>
						<button type="button" class="btn agree">
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				content-class="confirmation-dialog"
				v-model="modalDeleteSeat"
				max-width="400"
				persistent
			>
				<v-card>
					<v-card-text class="title text-xs-center pt-4">{{
						titleDialogDelete
					}}
						<p class="mt-2">Está seguro de eliminar el detalle, el asiento podría quedar descuadrado.</p>
					</v-card-text>
					<v-card-actions class="justify-center pb-4">
						<button
							type="button"
							class="btn cancel"
							@click="closeModalDeleteSeat"
						>
							No
						</button>
						<button type="button" class="btn agree" @click="eliminateSeat">
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
					<v-dialog v-model="modalWaitSeats" max-width="440" persistent>
			<v-card class="wait-modal">
				<div class="wait-modal__header">
					<span class="wait-modal__title">{{ waitTitle }}</span>
					<span class="wait-modal__subtitle">{{ waitSubtitle }}</span>
				</div>

				<div class="wait-steps">
					<div
						v-for="(moduleCode, index) in newModules"
						:key="moduleCode"
						class="wait-step"
						:class="stepClass(moduleCode)"
					>
						<span class="wait-step__icon">
							<span
								class="wait-step__spinner"
								v-if="stepStatus[moduleCode] === 'running'"
							></span>
							<template v-else>{{ stepIcon(moduleCode, index) }}</template>
						</span>

						<div class="wait-step__body">
							<span class="wait-step__name">{{ moduleCode }}</span>
							<span class="wait-step__status">{{ stepLabel(moduleCode) }}</span>

							<div
								class="wait-step__counts"
								v-if="moduleStats[moduleCode]"
							>
								<span
									class="wait-chip is-ok"
									v-if="moduleStats[moduleCode].totalProcessed"
								>
									{{ moduleStats[moduleCode].totalProcessed }} contabilizados
								</span>
								<span
									class="wait-chip is-bad"
									v-if="moduleStats[moduleCode].totalErrors"
								>
									{{ moduleStats[moduleCode].totalErrors }}
									{{ moduleStats[moduleCode].totalErrors === 1
										? 'con novedad' : 'con novedad' }}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="wait-modal__progress">
					<div class="wait-progress">
						<div
							class="wait-progress__bar"
							:style="{ width: `${waitPercent}%` }"
						></div>
					</div>
					<div class="wait-progress__labels">
						<span class="wait-progress__text">
							{{ waitDone }} de {{ newModules.length }}
							{{ newModules.length === 1 ? 'módulo procesado' : 'módulos procesados' }}
						</span>
						<span class="wait-progress__pct">{{ waitPercent }}%</span>
					</div>
				</div>

				<div class="wait-modal__actions">
					<button
						type="button"
						class="wait-btn"
						:disabled="flagbtnCloseSeatModal"
						@click="closeModalWaitSeat"
					>
						Cerrar
					</button>
				</div>
			</v-card>
		</v-dialog>
		</div>
	  <v-dialog
			v-model="showErrorModal"
			persistent
			width="450">
			<v-card class="modal-container-error">
				<v-card-title class="modal-container-error-title">
					<h4 class="text-xs-center">Error</h4>
					<close-icon class="cursor-pointer" @click="closeModalErrorSeat" />
				</v-card-title>
				<v-card-text class="modal-container-error-text">
					<span class="text-error-modal">Existen conflictos con los siguientes asientos contables: </span>
					<div class="layout wrap align-center"
						v-for="(error, index) in dataError" :key="index">
						<v-flex xs12 class="error-item" mb-2>
							<v-layout row wrap >
								<v-flex xs3 class="error-item-title">Asiento: </v-flex>
								<v-flex xs9 class="error-item-subtitle">{{ error.code }}</v-flex>
								<v-flex xs3 class="error-item-title">Descripción: </v-flex>
								<v-flex xs9 class="error-item-subtitle">{{ error.gloss }}</v-flex>
								<v-flex xs3 class="error-item-title">Debe: </v-flex>
								<v-flex xs3 class="error-item-subtitle">{{ error.totalDebe || 0 | formatAmount }}</v-flex>
								<v-flex xs3 class="error-item-title">Haber: </v-flex>
								<v-flex xs3 class="error-item-subtitle">{{ error.totalHaber  || 0 | formatAmount }}</v-flex>
							</v-layout>
						</v-flex>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showItemsBlock"
			persistent
			width="500">
			<v-card class="card-container-blocked">
				<v-card-text class="card-container-blocked-text">
					<p class="card-container-blocked-text-title">Asientos bloqueados por cierre de periodo:</p>
					<div class="card-container-blocked-text-list">
						<div
							v-for="(item, index) in itemsBlockedPeriod"
							:key="index"
							class="card"
							>
							<div class="card-header">
								<h3 class="card-title">Asiento: {{ item.code }}</h3>
							</div>
							<div class="card-body">
								<span class="card-description">Descripción: {{ item.gloss }}</span>
								<span class="card-description">Fecha: {{ item.date | exactDate }}</span>
								<span class="card-description">Módulo: {{ item.moduleName }}</span>
							</div>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="card-container-blocked-actions">
					<button
						type="button"
						class="btn-modal save"
						@click="closItemsBlock">
						Aceptar
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showItemsBlockAccounting"
			persistent
			width="500">
			<v-card class="card-container-blocked">
				<v-card-text class="card-container-blocked-text">
					<p class="card-container-blocked-text-title">Registros bloqueados para contabilización por cierre de periodo:</p>
					<div class="card-container-blocked-text-list">
						<div
							v-for="(item, index) in itemsBlockedPeriod"
							:key="index"
							class="card"
							>
							<div class="card-header">
								<h3 class="card-title">N° Documento:
									<span v-if="item.documentNumberComplete">
										<span v-if="item.documentNumberComplete && item.documentNumberComplete.length < 17">{{
											item.transactionId ||
												item.documentNumberComplete ||
												item.documentAccountStatusId ||
												item.code ||
												item.gloss ||
												item.documentNumber
										}}</span>
										<v-tooltip top v-else>
											<span slot="activator">{{
												item.id ||
													item.documentNumberComplete ||
													item.documentAccountStatusId ||
													item.code ||
													item.gloss ||
													item.documentNumber
											}}</span>
											<span>{{
												item.transactionId ||
													item.documentNumberComplete ||
													item.documentAccountStatusId ||
													item.code ||
													item.gloss ||
													item.documentNumber
											}}</span>
										</v-tooltip>
									</span>
									<span v-else>
										{{
											item.documentNumberComplete ||
												item.documentAccountStatusId ||
												item.code ||
												item.gloss ||
												item.documentNumber ||
												item.id
										}}
									</span>
								</h3>
							</div>
							<div class="card-body">
								<span class="card-description">Referencia: {{
									item.documents && item.documents != null
										? item.documents.toString()
										: item.observations ||
										item.documentNumber ||
										item.sendKardexMessage ||
										item.gloss ||
										item.description
								}}</span>
								<span class="card-description">Fecha: <span v-html="validateDateRow(item)"></span></span>
								<span class="card-description">Módulo: {{ item.moduleCode }}</span>
								<span class="card-description">Monto: {{ item.amount || item.totalDebe | formatAmount }}</span>
							</div>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="card-container-blocked-actions">
					<button
						type="button"
						class="btn-modal save"
						@click="closItemsBlock">
						Aceptar
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showDetails"
			persistent
			width="650">
			<v-card class="card-container-details" v-if="showDetails">
				<v-card-title class="card-container-details-title">
					<span>Detalle Registro</span>
					<close-icon class="cursor-pointer" @click="closeDetailDocument"></close-icon>
				</v-card-title>
				<v-card-text class="card-container-details-list">
					<v-layout wrap>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">N° Documento: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.moduleCode === 'CTAXCOB' || detailsRegister.moduleCode === 'CTAXPAG' ? detailsRegister.documentAccountStatus.documentNumber : detailsRegister.documentNumber }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Módulo Origen: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.moduleCode }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Fecha Registro: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.dateEmission || detailsRegister.paymentDate || detailsRegister.createdAt | exactDate }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Monto: </v-flex>
								<v-flex class="c-text-green">${{ detailsRegister.amount.toFixed(2) }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-2 px-1 body-1 v-if="detailsRegister.moduleCode !== 'BANCO' && detailsRegister.moduleCode !== 'CAJA'">
							<v-layout>
								<v-flex class="content-green">{{ getLabelRegister().label }}: </v-flex>
								<v-flex class="c-text-green">{{ getLabelRegister().value }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1>
							<v-layout>
								<v-flex class="content-green">Tipo de Pago: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.typePayment && detailsRegister.typePayment.name
									? detailsRegister.typePayment.name
									: detailsRegister.transactions
										&& detailsRegister.transactions.length > 0
										&& detailsRegister.transactions[0].typePayment
										&& detailsRegister.transactions[0].typePayment.name
										? detailsRegister.transactions[0].typePayment.name
										: detailsRegister.documentType.description ||'' }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-2 px-1 body-1 v-if="detailsRegister.moduleCode === 'CTAXPAG' || detailsRegister.moduleCode === 'CTAXCOB'">
							<v-layout>
								<v-flex class="content-green">Tipo de Trans: </v-flex>
								<v-flex class="c-text-green">{{ detailsRegister.typeAmortizationName }}</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<!-- ========== RESULTADO DE LA CONTABILIZACIÓN ========== -->
<v-dialog
	v-model="showResultModal"
	persistent
	scrollable
	width="760"
>
	<v-card class="result-modal">
		<v-card-title class="result-modal__header">
			<div>
				<span class="result-modal__title">Resultado de la contabilización</span>
				<span class="result-modal__subtitle">{{ resultSubtitle }}</span>
			</div>
			<close-icon class="cursor-pointer" @click="closeResultModal" />
		</v-card-title>

		<div class="result-modal__stats">
			<div class="result-modal__stat">
				<span class="result-modal__stat-value">{{ resultSummary.totalReceived }}</span>
				<span class="result-modal__stat-label">Enviados</span>
			</div>
			<div class="result-modal__stat is-ok">
				<span class="result-modal__stat-value">{{ resultSummary.totalProcessed }}</span>
				<span class="result-modal__stat-label">Contabilizados</span>
			</div>
			<div class="result-modal__stat is-error">
				<span class="result-modal__stat-value">{{ resultSummary.totalErrors }}</span>
				<span class="result-modal__stat-label">Con novedad</span>
			</div>
		</div>

		<v-card-text class="result-modal__body">
			<div v-if="!resultErrors.length" class="result-modal__empty">
				<v-icon color="#1fd9b6" size="44">check_circle</v-icon>
				<p>Todos los registros se contabilizaron correctamente.</p>
			</div>

			<div
				v-for="group in resultGroups"
				:key="group.stage"
				class="result-group"
			>
				<div
					class="result-group__header"
					:style="{ borderLeftColor: group.color }"
				>
					<span
						class="result-group__badge"
						:style="{ backgroundColor: group.color }"
					>{{ group.items.length }}</span>
					<div>
						<span class="result-group__title">{{ group.label }}</span>
						<span class="result-group__hint">{{ group.hint }}</span>
					</div>
				</div>

								<div
					v-for="(item, index) in group.items"
					:key="`${group.stage}-${index}`"
					class="result-item"
				>
					<div class="result-item__head">
						<span class="result-item__doc">
							{{ item.documentNumber || item.documentId || 'Sin número' }}
						</span>
						<span class="result-item__date" v-if="item.date">
							{{ item.date | exactDate }}
						</span>
					</div>

					<p class="result-item__gloss" v-if="item.gloss">{{ item.gloss }}</p>

					<p class="result-item__message">{{ errorMessage(item) }}</p>

					<div>
						<span class="result-tag is-module" v-if="item.moduleCode">
							{{ item.moduleCode }}
						</span>
						<span class="result-tag" v-if="item.moduleName">{{ item.moduleName }}</span>
						<span class="result-tag" v-if="item.code">Asiento: {{ item.code }}</span>
						<span class="result-tag" v-if="item.ruleCode">Regla: {{ item.ruleCode }}</span>
						<span class="result-tag is-debe" v-if="item.totalDebe || item.totalDebe === 0">
							Debe {{ item.totalDebe || 0 | formatAmount }}
						</span>
						<span class="result-tag is-haber" v-if="item.totalHaber || item.totalHaber === 0">
							Haber {{ item.totalHaber || 0 | formatAmount }}
						</span>
						<span class="result-tag is-diff" v-if="item.difference">
							Dif. {{ item.difference | formatAmount }}
						</span>
					</div>

					<!-- ---------- VER / OCULTAR DETALLE ---------- -->
					<span
						class="result-item__toggle"
						v-if="hasResultDetail(item)"
						@click="toggleResultDetail(`${group.stage}-${index}`)"
					>
						{{ isResultExpanded(`${group.stage}-${index}`)
							? '▾ Ocultar detalle'
							: '▸ Ver detalle del asiento' }}
					</span>

					<template v-if="isResultExpanded(`${group.stage}-${index}`)">

						<!-- ---------- DOCUMENTO ORIGEN ---------- -->
						<div class="result-sub" v-if="item.document && item.document.id">
							<span class="result-sub__title">Documento origen</span>
							<div class="result-doc">
								<div class="result-doc__field" v-if="item.document.entityName">
									<span class="result-doc__label">{{ item.document.entityType || 'Entidad' }}:</span>
									{{ item.document.entityName }}
								</div>
								<div class="result-doc__field" v-if="item.document.entityDocument">
									<span class="result-doc__label">Identificación:</span>
									{{ item.document.entityDocument }}
								</div>
								<div class="result-doc__field" v-if="item.document.number">
									<span class="result-doc__label">Tipo:</span>
									{{ item.document.typeDocument }} · {{ item.document.number }}
								</div>
								<div class="result-doc__field" v-if="item.document.amount !== null">
									<span class="result-doc__label">Monto:</span>
									{{ item.document.amount | formatAmount }}
									{{ (item.document.currency || '') | uppercase }}
								</div>
								<div class="result-doc__field" v-if="item.document.emissionDate">
									<span class="result-doc__label">Emisión:</span>
									{{ item.document.emissionDate | exactDate }}
								</div>
								<div class="result-doc__field" v-if="item.document.paymentDate">
									<span class="result-doc__label">Pago:</span>
									{{ item.document.paymentDate | exactDate }}
								</div>
								<div class="result-doc__field" v-if="item.document.concept">
									<span class="result-doc__label">Concepto:</span>
									{{ item.document.concept }}
								</div>
							</div>
						</div>

						<!-- ---------- ASIENTO GENERADO ---------- -->
						<div class="result-sub" v-if="item.details && item.details.length">
							<span class="result-sub__title">
								Asiento generado — {{ item.details.length }}
								{{ item.details.length === 1 ? 'línea' : 'líneas' }}
							</span>

							<table class="result-lines">
								<thead>
									<tr>
										<th style="width: 30%">Cuenta</th>
										<th style="width: 44%">Concepto</th>
										<th style="width: 13%" class="num">Debe</th>
										<th style="width: 13%" class="num">Haber</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(line, l) in item.details"
										:key="l"
										:class="{ 'is-invalid': !line.isValid }"
									>
										<td>
											<span v-if="line.accountCode || line.account">
												{{ line.accountCode || line.account }}
												<span class="result-line__name" v-if="line.accountName">
													{{ line.accountName }}
												</span>
											</span>
											<span class="result-line__account-empty" v-else>
												⚠ Sin cuenta asignada
											</span>
											<span class="result-line__rule" v-if="ruleAccountHint(line)"
												v-html="ruleAccountHint(line)"></span>
										</td>
										<td>
											{{ line.concept || '—' }}
											<span class="result-line__rule" v-if="ruleFormulaHint(line)"
												v-html="ruleFormulaHint(line)"></span>
										</td>
										<td class="num">
											{{ line.amountDebe ? (line.amountDebe | formatAmount) : '—' }}
										</td>
										<td class="num">
											{{ line.amountHaber ? (line.amountHaber | formatAmount) : '—' }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- ---------- ACCIONES ---------- -->
						<div class="result-actions">
							<button
								type="button"
								class="btn-mini is-primary"
								v-if="item.documentId"
								@click="goToResultDocument(item)"
							>
								Ver documento
							</button>
							<button
								type="button"
								class="btn-mini"
								@click="copyResultItem(item)"
							>
								Copiar este registro
							</button>
						</div>
					</template>
				</div>
			</div>
		</v-card-text>

		<v-card-actions class="result-modal__actions">
			<button
				type="button"
				class="btn-modal result-ghost"
				v-if="resultErrors.length"
				@click="copyResultErrors"
			>
				Copiar detalle
			</button>
			<button
				type="button"
				class="btn-modal save"
				@click="closeResultModal"
			>
				Aceptar
			</button>
		</v-card-actions>
	</v-card>
</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import appInputText from '@/components/autocomplete/app-input-text';
import actionBar from '@/components/shared/action-bar/action-bar';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appDateSelect from '@/components/shared/app-date-select';
import BaseSelect from '@/components/shared/inputs/base-select';
import { addHours, endOfMonth, format, isBefore, isEqual, subDays } from 'date-fns';
import dateComponent from '@/components/autocomplete/date-component';
import lib from '@/shared/lib';
import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
import codeModules from '@/shared/codeModules';
import closeIcon from '../../components/shared/icons/close.icon';

const { getDeeper } = lib;
let colorIndex = 0;
const RESULT_STAGES = [
	{
		stage: 'duplicado',
		label: 'Ya tenían asiento',
		hint: 'Se omitieron para no duplicar la contabilización',
		color: '#f5a623',
	},
	{
		stage: 'generar',
		label: 'No se pudo generar el asiento',
		hint: 'Falló una regla contable o faltan datos del documento',
		color: '#e53935',
	},
	{
		stage: 'cuentas-invalidas',
		label: 'Sin cuenta contable válida',
		hint: 'Revise la configuración de cuentas de la regla contable',
		color: '#8e24aa',
	},
	{
		stage: 'descuadrado',
		label: 'Asientos descuadrados',
		hint: 'El debe y el haber no coinciden',
		color: '#1e88e5',
	},
	{
		stage: 'guardar',
		label: 'No se pudo guardar',
		hint: 'El asiento se generó pero la base de datos lo rechazó',
		color: '#546e7a',
	},
];

// Recurso ACL de esta pantalla (= $route.name). Verifica con window.permsDebug.map
// que sea 'batch-accounting'. El botón "Contabilizar Registro" (post-record) ya lo
// filtra el action-bar; aquí gateamos editar/eliminar del detalle y los asientos.
function permsResource() {
	return (this.$route && this.$route.name) || '';
}
function canEdit() {
	return this.$can(this.permsResource, 'update');
}
function canDelete() {
	return this.$can(this.permsResource, 'delete');
}
function canCreate() {
	return this.$can(this.permsResource, 'create');
}

async function created() {
	// Periodos solo de la sucursal actual; si falla, la pantalla igual debe cargar.
	const subsidiaryId = this.subsidiaryId || (this.currentSubsidiary && this.currentSubsidiary.id);
	let dataPeriods = [];
	try {
		({ data: dataPeriods } = await this.$http.get('period-con', { params: { subsidiaryId } }));
	} catch (error) {
		dataPeriods = [];
	}
	const availablePeriod = (dataPeriods || [])
		.find(t => t.flagActive === 1 && t.transactionBlockingModule
			&& Number(t.subsidiaryId) === Number(subsidiaryId));
	this.transactionBlockingModule = availablePeriod
		&& availablePeriod.transactionBlockingModule
		? availablePeriod.transactionBlockingModule : {};
	this.loadModules();
	this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.model.endDate = this.$today;
	window.addEventListener('resize', this.reziseMobile);
	this.model.status = 3;
	this.model.accountingSeat = 0;
	if (this.model.accountingSeat === 0) {
		this.flagStateRecord = false;
	}
	this.reziseMobile();
	this.subsidiaryId = this.currentSubsidiary.id;
	const { data: response } = await this.$http.get(`settings/${this.currentSubsidiary.customerId}/${this.currentSubsidiary.id}`);
	this.settings = response.additionalSettings;
	this.loadAccounts();
	this.loadCostCenter();
}

async function loadModules() {
	const params = {
		subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
	};
	({ data: this.modules } = await this.$http.get('type-register', { params }));
	if (this.modules.length === 1) {
		this.model.moduleId = this.modules[0].id;
	}
	this.modulesFilter = this.modules;
	const newArrayModules = [
		{ code: 'CTAXCOBFAC', name: 'OTROS DOC. CXC' },
		{ code: 'CTAXPAGFAC', name: 'OTROS DOC. CXP' },
		{ code: 'TODOS', name: 'TODOS' },
	];
	this.modulesFilter = this.modulesFilter.concat(newArrayModules);
	this.modulesFilter = this.modulesFilter.map(module => ({
		...module,
		color: this.statusColorModules(module),
		name: this.statusNameModules(module),
	}));
}

function setModule(value) {
	this.model.moduleId = value;
	this.flagNewModules = value === 'CTAXCOBFAC' || value === 'CTAXPAGFAC';
	this.titleModule = `REGISTROS DE MÓDULO ${this.model.moduleId}`;
	this.titleModuleSeat = `ASIENTOS CREADOS MÓDULO  ${this.model.moduleId}`;
	const index = this.modules.findIndex(m => m.code === value);
	if (index > -1) {
		this.valuesShow = this.modules[index].templateJson || {};
	}
	if (this.model.moduleId !== 'VENTA') {
		this.model.typeFac = null;
	}
}
async function setStatusRecords(value) {
	this.model.accountingSeat = value;
	this.flagStateRecord = false;
}

function setStatusFac(value) {
	this.model.typeFac = value;
}

async function setStatus(value) {
	this.model.status = value;
	if (this.model.status === 1) {
		this.flagStatusAccounting = true;
	} else {
		this.flagStatusAccounting = false;
	}
	this.loadAccountingDetail();
	this.selectedAllSeat();
}
async function setTypes(value) {
	this.model.square = value;
	if (this.model.square === 2) {
		this.flagNoConfirm = true;
	} else {
		this.flagNoConfirm = false;
	}
	await this.loadAccountingDetail.call(this);
	this.selectedAllSeat();
}

async function onPage(page) {
	this.currentPageDetail = page;
	await this.loadAccountingDetail.call(this);
}

async function loadAccountingDetail() {
	const params = {
		subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
		status: this.model.status,
		moduleCode: this.model.moduleId === 'TODOS' ? null : this.verifyNewModules(this.model.moduleId),
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		square: this.model.square,
		page: this.currentPageDetail,
		limit: 100,
	};
	try {
		const response = await this.$http.get('accounting-seats', { params });
		this.lastPageDetails = Number(response.headers['x-last-page']);
		this.itemsTotalQuantityDetails = Number(response.headers['x-quantity']);
		this.rowsSeat = response.data.map((row) => {
			const newRow = { ...row };
			const module = this.modulesFilter.find(mod => mod.code === row.typeRegister.code);
			newRow.moduleCode = module.code;
			newRow.color = module ? module.color : '#03888c';
			newRow.isSelected = false;
			return newRow;
		});
	} catch (error) {
		this.showGenericError();
	} finally {
		const activeFlagPage = true;
		this.dialogLoading = false;
		this.loadAccounting(activeFlagPage);
	}
}

function verifyNewModules(code) {
	if (code === 'CTAXCOBFAC' || code === 'CTAXPAGFAC') {
		if (code === 'CTAXCOBFAC') {
			return 'CTAXCOB';
		}
		return 'CTAXPAG';
	}
	return code;
}

async function loadAccounting(flagPage) {
	const flagActivePage = flagPage;
	this.loading = true;
	if (this.model.moduleId !== 'Contabilidad') {
		if (this.model.moduleId === 'VENTA') {
			this.model.moduleId = 1;
		}
		if (this.model.moduleId === 'COMPRA') {
			this.model.moduleId = 2;
		}
		if (this.model.moduleId === 'CTAXPAG' || this.model.moduleId === 'CTAXPAGFAC') {
			this.model.moduleId = 3;
		}
		if (this.model.moduleId === 'CTAXCOB' || this.model.moduleId === 'CTAXCOBFAC') {
			this.model.moduleId = 4;
		}
		if (this.model.moduleId === 'INGRESOS') {
			this.model.moduleId = 6;
		}
		if (this.model.moduleId === 'EGRESOS') {
			this.model.moduleId = 7;
		}
		if (this.model.moduleId === 'CAJA') {
			this.model.moduleId = 8;
		}
		if (this.model.moduleId === 'BANCO') {
			this.model.moduleId = 9;
		}
		if (this.model.moduleId === 'NOMINA') {
			this.model.moduleId = 10;
		}
		if (this.model.moduleId === 'TODOS') {
			this.model.moduleId = 11;
		}
		if (this.model.moduleId === 'CVENTA') {
			this.model.moduleId = 12;
		}
		if (this.model.moduleId === 'ANTICIPOS') {
			this.model.moduleId = 13;
		}
		this.dialogLoading = true;
		const params = {
			accountingSeat: this.model.accountingSeat,
			startDate: this.model.startDate,
			endDate: this.model.endDate,
			search: this.model.search,
			typeFac: this.model.typeFac,
			subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
			page: flagActivePage ? 1 : this.currentPage,
			limit: this.model.moduleId === 11 ? 50 : 100,
			flagForNull:
				this.model.moduleId === 1 || this.model.moduleId === 2 ||
					this.model.moduleId === 11 ? 1 : null,
		};
		if (this.flagNewModules) {
			params.flagFacWithDocStatus = true;
		}
		try {
			const response = await this.$http.get(
				`registers/accounting-seat/${this.model.moduleId}?&sortField=created_at`,
				{ params },
			);
			this.itemsTotalQuantity = Number(response.headers['x-quantity']);
			this.rows = response.data.map((row) => {
				const newRow = { ...row };
				newRow.isSelected = false;
				const flag = Object.keys(this.valuesShow).length;
				const module = this.modulesFilter.find(mod => mod.code === row.moduleCode);
				newRow.color = module ? module.color : '#03888c';
				const searchDate = flag ? this.valuesShow.date.split('.') : null;
				const searchEntity = flag ? this.valuesShow.entity.split('.') : null;
				const searchReference = flag
					? this.valuesShow.reference.split('.')
					: null;
				const searchAmount = flag ? this.valuesShow.amount.split('.') : null;
				newRow.dateToShow = searchDate ? getDeeper(...searchDate)(row) : null;
				newRow.entityToShow = searchEntity
					? getDeeper(...searchEntity)(row)
					: null;
				newRow.referenceToShow = searchReference
					? getDeeper(...searchReference)(row)
					: null;
				newRow.amountToShow = searchAmount
					? getDeeper(...searchAmount)(row)
					: null;
				return newRow;
			});
			console.log('this.rows::: ', this.rows);
			this.lastPage = Number(response.headers['x-last-page']);
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			} else if (error.status === 400) {
				if (error.data.message === 'SUBSIDIARY_NOT_CONFIG_FILTERS') {
					this.showGenericError(
						'Empresa sin configuración de integración a Firebase',
					);
				}
			}
		} finally {
			this.dialogLoading = false;
			if (this.model.moduleId === 1) {
				this.model.moduleId = 'VENTA';
			}
			if (this.model.moduleId === 2) {
				this.model.moduleId = 'COMPRA';
			}
			if (this.model.moduleId === 3 && this.flagNewModules) {
				this.model.moduleId = 'CTAXPAGFAC';
			}
			if (this.model.moduleId === 4 && this.flagNewModules) {
				this.model.moduleId = 'CTAXCOBFAC';
			}
			if (this.model.moduleId === 3) {
				this.model.moduleId = 'CTAXPAG';
			}
			if (this.model.moduleId === 4) {
				this.model.moduleId = 'CTAXCOB';
			}
			if (this.model.moduleId === 6) {
				this.model.moduleId = 'INGRESOS';
			}
			if (this.model.moduleId === 7) {
				this.model.moduleId = 'EGRESOS';
			}
			if (this.model.moduleId === 8) {
				this.model.moduleId = 'CAJA';
			}
			if (this.model.moduleId === 9) {
				this.model.moduleId = 'BANCO';
			}
			if (this.model.moduleId === 10) {
				this.model.moduleId = 'NOMINA';
			}
			if (this.model.moduleId === 11) {
				this.model.moduleId = 'TODOS';
			}
			if (this.model.moduleId === 12) {
				this.model.moduleId = 'CVENTA';
			}
			if (this.model.moduleId === 13) {
				this.model.moduleId = 'ANTICIPOS';
			}
			this.loading = false;
		}
	} else {
		this.loading = false;
	}
}

function rowIsSelected({ id, isSelected }) {
	this.checkAll = this.rows.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelected.push(this.rows.find(row => row.id === id));
	} else {
		const index = this.dataSelected.findIndex(row => row.id === id);
		this.dataSelected.splice(index, 1);
	}
}

function clearAccouting() {
	this.model.moduleId = null;
	this.showAccouting = false;
	this.valuesShow = {};
	this.rows = [];
	this.rowsSeat = [];
}

function onSearch(value) {
	this.model.search = value || null;
	this.loadAccounting();
}

function selectedAll(checked) {
	console.log('checked::: ', checked);
	this.checkAll = checked;
	this.rows = this.rows.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelected = this.rows.filter(r => r.isSelected);
}
function selectedAllSeat(checked) {
	this.checkAllAccounting = checked;
	this.rowsSeat = this.rowsSeat.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelectedAccounting = this.rowsSeat.filter(r => r.isSelected);
}
function openDetail(row) {
	this.dialogDetailAccounting = true;
	this.dataSeat = { ...row };
	this.nameAccouting = `${row.code} - ${row.gloss}`;
	this.rowsDetailModal = row.details.map((det) => {
		const newDet = { ...det };
		newDet.edit = false;
		return newDet;
	});
	this.periodLock = this.validatePeriodLock(row);
}

function openDetailRegister(row) {
	console.log('row::: ', row);
	this.detailsRegister = { ...row };
	this.showDetails = true;
}

function validatePeriodLock(row) {
	const module = codeModules[row.moduleCode];
	if (this.transactionBlockingModule && this.transactionBlockingModule[module]) {
		const formatDate = format(addHours(row.date, 5), 'YYYY-MM-DD');
		return isBefore(formatDate, this.transactionBlockingModule[module])
			|| isEqual(formatDate, this.transactionBlockingModule[module]);
	}
	return false;
}

function changePage(page) {
	this.currentPage = page;
	this.model.page = page;
	this.loadAccounting();
	this.dataSelected = [];
}

function statusColor({ status }) {
	return status === 1 ? 'success' : 'error';
}

function statusName({ status }) {
	return status === 1 ? 'Correcto' : 'Pendiente';
}

function statusColorModules() {
	// Lista de 13 colores
	const colors = [
		'#03888c', // Color base
		'#4caf50', // Verde azulado oscuro
		'#00A896', // Verde azulado claro
		'#7FC1C0', // Cian pastel suave
		'#B2DFDB', // Cian muy claro
		'#FFCC80', // Amarillo pastel
		'#FFAB91', // Coral pastel
		'#EF9A9A', // Rojo pastel
		'#B39DDB', // Violeta pastel
		'#90CAF9', // Azul pastel
		'#80CBC4', // Verde azulado pastel
		'#A5D6A7', // Verde pastel
		'#F48FB1', // Rosa pastel
	];
	const color = colors[colorIndex % colors.length];
	colorIndex += 1; // Incrementar el índice para el próximo código
	return color;
}

function statusNameModules({ name }) {
	// Devuelve el nombre del elemento
	return name;
}

async function saveAccouting() {
	const body = {
		ids: this.dataSelectedAccounting.map(accounting => accounting.id),
	};
	try {
		await this.$http.patch('accounting-seat/confirm', body);
		this.showNotification('Los asientos fueron asignados correctamente');
		this.loadAccountingDetail();
		this.loadAccounting();
		this.dataSelectedAccounting = [];
	} catch (error) {
		this.showGenericError();
	} finally {
		this.selectedAllSeat();
	}
}

function rowIsSelectedAccounting({ id, isSelected }) {
	this.checkAllAccounting = this.rowsSeat.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelectedAccounting.push(this.rowsSeat.find(row => row.id === id));
	} else {
		const index = this.dataSelectedAccounting.findIndex(row => row.id === id);
		this.dataSelectedAccounting.splice(index, 1);
	}
}

function closeDialog() {
	this.nameAccouting = null;
	this.dialogDetailAccounting = false;
	this.openDetailSeat = false;
	this.periodLock = false;
}

function getType({ amount }) {
	return amount < 0 ? 'H' : 'D';
}

function getDate({ value, model }) {
	if (model === 'startDate') {
		this.model[model] = format(value, 'YYYY-MM-DD');
		this.model.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
	} else if (model === 'endDate') {
		this.model[model] = format(value, 'YYYY-MM-DD');
	}
}

function disabledConfirm() {
	return !this.dataSelectedAccounting.length > 0;
}

async function postRecord() {
	this.resetAccountingResult();
	if (this.model.moduleId === 1) {
		this.model.moduleId = 'VENTA';
	}
	if (this.model.moduleId === 2) {
		this.model.moduleId = 'COMPRA';
	}
	if (this.model.moduleId === 3) {
		this.model.moduleId = 'CTAXPAG';
	}
	if (this.model.moduleId === 4) {
		this.model.moduleId = 'CTAXCOB';
	}
	if (this.model.moduleId === 6) {
		this.model.moduleId = 'INGRESOS';
	}
	if (this.model.moduleId === 7) {
		this.model.moduleId = 'EGRESOS';
	}
	if (this.model.moduleId === 8) {
		this.model.moduleId = 'CAJA';
	}
	if (this.model.moduleId === 9) {
		this.model.moduleId = 'BANCO';
	}
	if (this.model.moduleId === 10) {
		this.model.moduleId = 'NOMINA';
	}
	if (this.model.moduleId === 12) {
		this.model.moduleId = 'CVENTA';
	}
	if (this.model.moduleId === 13) {
		this.model.moduleId = 'ANTICIPOS';
	}
	if (this.model.moduleId === 'CTAXCOBFAC') {
		this.model.moduleId = 'CTAXCOB';
	}
	if (this.model.moduleId === 'CTAXPAGFAC') {
		this.model.moduleId = 'CTAXPAG';
	}
	if (this.model.moduleId === 'TODOS') {
		if (this.dataSelected.some(item => item.moduleCode === 'BANCO')) {
			const existingIds = new Set(this.dataSelected.map(item => item.id));
			const itemsToAdd = [];
			this.dataSelected.forEach((item) => {
				if (item.typeTransaction === 3 && item.transactionBankToBankId &&
					!existingIds.has(item.transactionBankToBankId)) {
					itemsToAdd.push({
						moduleCode: 'BANCO',
						id: item.transactionBankToBankId,
					});
					existingIds.add(item.transactionBankToBankId);
				}
			});
			this.dataSelected.push(...itemsToAdd);
		}
		this.modalWaitSeats = true;
		this.flagbtnCloseSeatModal = true;
		this.newModules = [...new Set(this.dataSelected.map(p => p.moduleCode))];
		// Inicializar el estado de cada módulo
		this.moduleStats = {};
		this.newModules.forEach((moduleCode) => {
			this.$set(this.stepStatus, moduleCode, 'pending');
		});
		// Procesar cada módulo con forEach
		await this.newModules.reduce(async (previousPromise, moduleCode) => {
			await previousPromise; // Esperar a que la iteración anterior se complete
			// Filtrar dataSelected para el módulo actual
			const newDataSelected = this.dataSelected.filter(p => p.moduleCode === moduleCode);

			const filterAvailableItems = newDataSelected.filter((item) => {
				const module = codeModules[item.moduleCode];
				const dateModule = this.getDateItem(item);
				if (this.transactionBlockingModule && this.transactionBlockingModule[module]) {
					const isBlocked = isBefore(dateModule, this.transactionBlockingModule[module])
						|| isEqual(dateModule, this.transactionBlockingModule[module]);
					if (isBlocked) {
						this.itemsBlockedPeriod.push(item);
						return null;
					}
					return item;
				}
				return item;
			});
			if (filterAvailableItems.length === 0) {
				this.$set(this.stepStatus, moduleCode, 'skipped');
				this.showNotification(
					`No se pueden contabilizar registros de ${moduleCode} con fechas fuera del periodo de cierre. Para continuar, ajuste la fecha de cierre para estos tipos de registros.`,
					'warning',
				);
			} else {
				try {
					// Construir el body para la solicitud
					const body = {
						ruc: this.currentSubsidiary.documentNumber,
						documents: filterAvailableItems.map(p => p.id),
					};

					// Parámetros de la solicitud
					const subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
					const params = {
						subsidiaryId,
					};

					if (moduleCode === 'CTAXCOBFAC' || moduleCode === 'CTAXPAGFAC') {
						params.flagFacWithDocStatus = true;
					}

					// Mostrar diálogo de espera
					this.dialogAction = false;

					// Consumir el servicio
					let newSetModule = moduleCode;
					if (newSetModule === 'CTAXCOBFAC') {
						newSetModule = 'CTAXCOB';
					} else if (newSetModule === 'CTAXPAGFAC') {
						newSetModule = 'CTAXPAG';
					}
					this.$set(this.stepStatus, moduleCode, 'running');
					// Esperar 8 segundos antes de consumir el servicio
					await new Promise(resolve => setTimeout(resolve, 8000));
					// Consumir el servicio después de la espera
					// Consumir el servicio después de la espera
					const { data: resultModule } = await this.$http.post(
						`accounting-seat/${newSetModule}/multiple`, // Usar moduleCode en la URL
						body,
						{ params },
					);

					const moduleSummary = this.collectAccountingResult(resultModule, moduleCode);

					// Rojo solo si NINGÚN registro del módulo se pudo contabilizar
					this.$set(this.moduleStats, moduleCode, moduleSummary);

					if (moduleSummary.totalErrors > 0 && moduleSummary.totalProcessed === 0) {
						this.$set(this.stepStatus, moduleCode, 'error');
					} else if (moduleSummary.totalErrors > 0) {
						this.$set(this.stepStatus, moduleCode, 'warning');
					} else {
						this.$set(this.stepStatus, moduleCode, 'complete');
					}

					if (moduleSummary.totalErrors > 0) {
						this.showNotification(
							`Módulo ${moduleCode}: ${moduleSummary.totalProcessed} contabilizados, ` +
							`${moduleSummary.totalErrors} con novedad.`,
							'warning',
						);
					} else {
						this.showNotification(`Los registros del módulo ${moduleCode} se guardaron correctamente.`);
					}
				} catch (error) {
					// Actualizar el estado del paso a "error"
					this.$set(this.stepStatus, moduleCode, 'error');
					// Manejo de errores
					if (error.response && error.response.status === 400) {
						this.showNotification(`Error en el módulo ${moduleCode}: ${error.response.data.message}`, 'warning');
					} else if (error.response && error.response.status === 500) {
						this.showNotification(`Error en el módulo ${moduleCode}: ${error.response.data.message}`, 'warning');
					} else if (error.data.message === 'SEATS_DUPLICATE') {
						this.showErrorModal = true;
						this.dataError = error.data.dataError;
					} else {
						this.showGenericError();
					}
				}
			}
		}, Promise.resolve());
		// Finalizar el proceso
		this.dataSelected = [];
		this.flagbtnCloseSeatModal = false;
		this.loadAccountingDetail();
		this.selectedAll();
		if (this.resultErrors.length > 0) {
			this.showResultModal = true;
		}
		if (this.itemsBlockedPeriod.length > 0) {
			this.showItemsBlockAccounting = true;
			this.modalWaitSeats = false;
			this.closeDialogAction();
			this.dialogAction = false;
		}
	} else {
		if (this.model.moduleId === 'BANCO') {
			this.dataSelected.forEach((item) => {
				if (
					item.typeTransaction === 3 &&
					item.transactionBankToBankId
				) {
					this.dataSelected.push({
						moduleCode: 'BANCO',
						id: item.transactionBankToBankId,
					});
				}
			});
		}
		console.log('this.dataSelectedzzzzzzz::: ', this.dataSelected);
		const filterAvailableItems = this.dataSelected.filter((item) => {
			const module = codeModules[item.moduleCode];
			const dateModule = this.getDateItem(item);
			if (this.transactionBlockingModule && this.transactionBlockingModule[module]) {
				const isBlocked = isBefore(dateModule, this.transactionBlockingModule[module])
					|| isEqual(dateModule, this.transactionBlockingModule[module]);
				if (isBlocked) {
					this.itemsBlockedPeriod.push(item);
					return null;
				}
				return item;
			}
			return item;
		});
		if (filterAvailableItems.length === 0) {
			this.closeDialogAction();
			this.showNotification('No se pueden contabilizar registros con fechas fuera del periodo de cierre. Para continuar, ajuste la fecha de cierre para estos tipos de registros.', 'warning');
		} else {
			const body = {
				ruc: this.currentSubsidiary.documentNumber,
				documents: filterAvailableItems.map(p => p.id),
			};
			const subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			const params = {
				subsidiaryId,
			};
			if (this.flagNewModules) {
				params.flagFacWithDocStatus = true;
			}
			try {
				this.dialogAction = false;
				this.dialogWait = true;
				const { data: resultAccounting } = await this.$http.post(
					`accounting-seat/${this.model.moduleId}/multiple`,
					body,
					{ params },
				);

				const resultSummary = this.collectAccountingResult(
					resultAccounting,
					this.model.moduleId,
				);

				this.dialogWait = false;

				if (this.resultErrors.length > 0) {
					this.showResultModal = true;
					this.showNotification(
						`${resultSummary.totalProcessed} contabilizados, ` +
						`${resultSummary.totalErrors} con novedad.`,
						'warning',
					);
				} else {
					this.showNotification('Los registros se guardaron correctamente.');
				}

				this.closeDialogAction();
				// this.loadAccountingDetail();
				this.dataSelected = [];
			} catch (error) {
				this.dialogWait = false;
				if (error.data.message === 'SOME_WRONG_ACCOUNTING_SEATS') {
					this.showNotification('Existen detalles de uno o más asientos sin cuentas contables', 'warning');
				} else if (error.data.message === 'OUT_OF_SQUQRE_SEATS') {
					this.showNotification('Existen asientos Descuadrados', 'warning');
				} else if (error.data.message === 'SEATS_DUPLICATE') {
					this.showErrorModal = true;
					this.dataError = error.data.dataError;
				} else {
					this.showGenericError();
				}
			} finally {
				this.loadAccountingDetail();
				this.selectedAll();
			}
		}
		if (this.itemsBlockedPeriod.length > 0) {
			this.showItemsBlockAccounting = true;
			this.modalWaitSeats = false;
		}
	}
}

function getDateItem(item) {
	if (item.moduleId) {
		if (item.moduleId === 3 || item.moduleId === 4) {
			if (item.typeTransactionId === 5 && !item.saleDocumentId) {
				return format(addHours(item.emissionDate, 5), 'YYYY-MM-DD');
			}
			if (!item.flagFacWithDocStatus) {
				const paymentDate = item.additionalInformation &&
					item.additionalInformation.paymentDate ?
					item.additionalInformation.paymentDate : item.paymentDate;
				return format(addHours(paymentDate, 5), 'YYYY-MM-DD');
			}
			return format(addHours(item.createdAt, 5), 'YYYY-MM-DD');
		}
		if (item.moduleId === 8 || item.moduleId === 9) {
			return item.paymentDate && item.paymentDate
				? format(addHours(item.paymentDate, 5), 'YYYY-MM-DD') : format(addHours(item.createdAt, 5), 'YYYY-MM-DD');
		}
		return format(addHours(item.createdAt || item.dateEnd, 5), 'YYYY-MM-DD');
	} else if (item.moduleCode === 'BANCO' || item.moduleCode === 'CAJA') {
		return item.paymentDate && item.paymentDate
			? format(addHours(item.paymentDate, 5), 'YYYY-MM-DD') : format(addHours(item.createdAt, 5), 'YYYY-MM-DD');
	}
	return format(addHours(item.createdAt || item.dateEnd, 5), 'YYYY-MM-DD');
}

function closeModalErrorSeat() {
	this.showErrorModal = false;
	this.dataError = [];
}

function closeDialogAction() {
	this.dialogAction = false;
}

function runAction({ codeWeb }) {
	if (codeWeb === 'post-record') {
		this.dialogAction = true;
	} else {
		// Guarda por permiso: no permite eliminar asientos sin 'delete'.
		if (!this.canDelete) return;
		this.rowsIds = this.rowsSeat
			.filter(i => i.isSelected === true)
			.map(row => row.id);
		this.rowIdsModules = this.rowsSeat
			.filter(i => i.isSelected === true)
			.map(row => ({
				id: row.id,
				moduleName: row.typeRegister.code,
				gloss: row.gloss,
				additionalInformation: row.additionalInformation ? row.additionalInformation : {},
				date: row.date,
				code: row.code,
			}));
		this.cancelModal = true;
	}
}

function valuesDisabled() {
	if (this.dataSelected.length < 1) {
		return [{ code: 'post-record', disabled: true }];
	}
	return [];
}

function getDataDate(val) {
	if (val === 1) {
		this.model.startDate = this.$today;
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = true;
	}
}

function loadCont() {
	this.dataSelected = [];
	this.rowsSeat = [];
	this.rows = [];
	this.dialogLoading = true;
	this.showAccouting = true;
	this.loadAccountingDetail();
	this.selectedAllSeat();
	this.selectedAll();
}

function openDialogDelete() {
	this.titleDialogDelete = '¿Está seguro que desea eliminar el asiento?';
	this.dialogDeleteAccounting = true;
}

function closeDialogAccouting() {
	this.dialogDeleteAccounting = false;
}

function goToEditAccouting() {
	const routeData = this.$router.resolve({
		name: 'page-edit-accounting',
		params: {
			subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
			moduleId: this.model.moduleId,
		},
	});
	window.open(routeData.href, '_blank');
}
function setId() {
	this.cancelModal = false;
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}
async function loadAccounts() {
	const params = {
		status: 1,
	};
	({ data: this.accounts } = await this.$http.get(
		`accounting-plan/${this.subsidiaryId}/subsidiary`, { params }));
	this.accounts = this.accounts.map((acc) => {
		const newAcc = { ...acc };
		newAcc.disabled = acc.stat === 1;
		return newAcc;
	});
}

async function loadCostCenter() {
	const response = await this.$http.get(`cost-center/${this.currentSubsidiary.id}/subsidiary`);
	this.costCenters = response.data;
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}
async function onDeleteSeat() {
	try {
		// Usamos map en lugar de forEach para obtener un array de promesas
		this.flagWait = true;
		const promises = this.rowIdsModules.map(async (item) => {
			if (this.transactionBlockingModule
				&& this.transactionBlockingModule[codeModules[item.moduleName]]) {
				const formatDate = format(addHours(item.date, 5), 'YYYY-MM-DD');
				const codeBlokingModule = codeModules[item.moduleName];
				const isBlockItem = isBefore(formatDate, this.transactionBlockingModule[codeBlokingModule])
					|| isEqual(formatDate, this.transactionBlockingModule[codeBlokingModule]);
				if (isBlockItem) {
					this.itemsBlockedPeriod.push(item);
					return;
				}
			}
			const { id, moduleName, gloss, additionalInformation } = item;
			if (moduleName === 'CAJA' || moduleName === 'BANCO') {
				const numberDocument = gloss.match(/\d+/)[0];
				this.documentNumberUpdate = numberDocument;
			}
			const payload = {
				moduleCode: moduleName,
			};
			const params = {};
			if (additionalInformation && additionalInformation.flagFacWithDocStatus) {
				params.flagFacWithDocStatus = true;
			}
			const response =
				moduleName === 'COMPRA'
					? await this.$http.patch(
						`accounting-seat-cancel/${id}?flagCancel=${this.flagCancel}`,
						payload,
					)
					: await this.$http.patch(`accounting-seat-cancel/${id}`, payload, { params });

			if (response.status === 200) {
				if (moduleName === 'CAJA' || moduleName === 'BANCO') {
					await this.$http.patch(
						`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`,
						{ ids: [id] },
					);
				}
			}
		});
		// Esperar a que todas las promesas se resuelvan antes de continuar
		await Promise.all(promises);
	} catch (error) {
		this.showGenericError();
	} finally {
		// Llamar a onDeleteSeatMultiple después de que todas las llamadas se completen
		this.onDeleteSeatMultiple();
		this.selectedAllSeat();
	}
}
async function onDeleteSeatMultiple() {
	const ids = {
		ids: this.rowsIds.filter(id =>
			!this.itemsBlockedPeriod.some(item => item.id === id)),
	};
	try {
		await this.$http.delete('accounting-seat', { data: ids });
		this.showNotification('La eliminación ha sido realizada correctamente.');
		this.closeModal();
		this.params.subsidiaryId =
			this.subsidiaryId || this.currentSubsidiary.id || null;
		if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		} else {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		await this.loadAccountingDetail.call(this);
		this.setId();
		this.flagWait = false;
		if (this.itemsBlockedPeriod.length > 0) {
			this.showItemsBlock = true;
		}
	}
}
function openMobileAccouting() {
	this.openMobile = !this.openMobile;
}

function closeMobile() {
	this.detailJournalOpen = false;
	this.openMobile = false;
}

function verifySubsidiary() {
	if (Object.keys(this.currentSubsidiary).length > 0) {
		return true;
	}
	this.showNotification('Seleccione una Sucursal', 'warning');
	return false;
}

function editSeats(row, index) {
	if (!this.canEdit) return;
	this.indexRowDetail = index;
	// this.rowsDetailModal[index].edit = true;
	this.rowsDetailModal = this.rowsDetailModal.map((d, indexD) => {
		const newDataDetail = { ...d };
		newDataDetail.edit = indexD === index;
		return newDataDetail;
	});
	const firstDigit = row.accountingAccount.account.charAt(0);
	this.flagValidNumberAccount = ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
		&& row.costCenterId === null);
	if (this.settings.autoCenterCost) {
		if ((Number(firstDigit) < 4 && Number(firstDigit) > 8)
			&& this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = true;
		} else if ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
			&& !this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = true;
		} else if ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
			&& this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = false;
		}
	}
}

function changeAmountSeat(item) {
	const { row, value, index } = item;
	if (row.type === 1) {
		this.rowsDetailModal[index].amount =
			value < 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountDebe =
			value < 0 ? Number(value * -1) : Number(value);
	} else {
		this.rowsDetailModal[index].amount =
			value > 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountHaber =
			value < 0 ? Number(value) * -1 : Number(value);
	}
}
function changeAccount(item) {
	const { value, index } = item;
	if (this.settings && this.settings.stat && value.stat === 1) {
		const findAccount = this.accounts
			.find(acc => acc.id === this.rowsDetailModal[index].accountingAccountId);
		this.rowsDetailModal[index].accountingAccount = findAccount;
		this.rowsDetailModal[index].accountingAccountId = findAccount.id;
		this.rowsDetailModal[index].account = findAccount.code;
		this.showNotification('La cuenta no se puede seleccionar', 'warning');
	} else {
		this.rowsDetailModal[index].accountingAccount = value;
		this.rowsDetailModal[index].accountingAccountId = value.id;
		this.rowsDetailModal[index].account = value.code;
	}
}

function changeCostCenter(item) {
	const { value, index } = item;
	this.rowsDetailModal[index].costCenter = value;
	this.rowsDetailModal[index].costCenterId = value.id;
	const firstDigit = this.rowsDetailModal[index].accountingAccount.account.charAt(0);
	this.flagValidNumberAccount = ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
		&& this.rowsDetailModal[index].costCenterId === null);
}

async function saveSeat(row, index) {
	try {
		this.rowsDetailModal[index].edit = false;
		const body = {
			account: row.accountingAccount.code,
			accountingAccountId: row.accountingAccount.id,
			amount: row.amount,
			concept: row.concept,
			costCenterId: row.costCenterId,
			reference: row.reference,
		};
		await this.$http.patch(
			`accounting-seat-details/${row.accountingSeatId}/${row.id}`,
			body,
		);
		this.loadAccountingDetail();
		this.showNotification('Asiento contable actualizado correctamente');
	} catch (error) {
		this.showGenericError();
	}
}
function deleteSeat(row, index) {
	if (!this.canDelete) return;
	this.indexRowDetail = index;
	this.modalDeleteSeat = true;
	this.titleDialogDelete = 'Eliminar Detalle De Asiento';
	this.rowForDelete = { ...row };
}
function closeModalDeleteSeat() {
	this.modalDeleteSeat = false;
	this.titleDialogDelete = '';
	this.rowForDelete = {};
}

function closeModalWaitSeat() {
	this.modalWaitSeats = false;
}
async function eliminateSeat() {
	this.rowsDetailModal.splice(this.indexRowDetail, 1);
	this.closeModalDeleteSeat();
}

function setValue(type, row) {
	let value;
	if (type === 'registro') {
		const strValue = row.amount.toString() || row.totalDebe.toString();
		value = this.refactorizeNumber(strValue);
	} else if (type === 'totalDebe') {
		const strValue = row.totalDebe.toString();
		value = this.refactorizeNumber(strValue);
	} else if (type === 'totalHaber') {
		const strValue = row.totalHaber.toString();
		value = this.refactorizeNumber(strValue);
	}
	return value;
}

function refactorizeNumber(value) {
	const decimalIndex = value.indexOf('.');
	if (decimalIndex === -1) {
		return `${value}.00`;
	}
	const integerPart = value.slice(0, decimalIndex);
	const decimalPart = value.slice(decimalIndex + 1, decimalIndex + 3);
	return `${integerPart}.${decimalPart.padEnd(2, '0')}`;
}

function validateSomeForceInsertCenterCost() {
	let valid = false;
	if (this.rowsDetailModal.length > 0) {
		if (this.settings.autoCenterCost) {
			valid = this.rowsDetailModal.some(d => /^[45678]/.test(d.accountingAccount.account) && d.costCenterId === null);
			if (valid) {
				this.showNotification('Hay cuentas con 4, 5, 6, 7, 8 sin centro de costo asignado');
			}
		}
		return valid;
	}
	return valid;
}

async function saveAllDetailsEdits() {
	if (!this.canEdit && !this.canCreate) return;
	this.isLoading = true;
	const body = this.formatData(this.rowsDetailModal);
	try {
		const { data: response } = await this.$http.patch(`accounting-seat-update-daily/${this.dataSeat.id}`, body);
		this.rowsDetailModal = response.details;
		this.rowsDetailModal = this.rowsDetailModal.map((ds) => {
			const newDs = { ...ds };
			newDs.accountingAccount = this.accounts.find(a => a.id === ds.accountingAccountId);
			newDs.costCenterId = ds.costCenterId ? ds.costCenterId : null;
			newDs.costCenter = this.costCenters.find(cc => cc.id === ds.costCenterId);
			newDs.amount = ds.amountDebe > 0 ? ds.amountDebe : (ds.amountHaber * -1);
			return newDs;
		});
		this.showNotification('Detalles actualizados Correctamente');
		// this.closeDialog();
		this.loadCont();
	} catch (error) {
		this.showGenericError();
	} finally {
		this.dialogDetailAccounting = false;
		this.openDetailSeat = false;
		this.isLoading = false;
		this.flagValidCostCenter = false;
		this.flagValidNumberAccount = false;
	}
}

function formatData(value) {
	const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
	const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
	const details = value.map((d) => {
		const newD = {};
		newD.id = d.id ? d.id : null;
		newD.type = d.type;
		newD.account = d.account || null;
		newD.concept = d.concept;
		newD.reference = d.reference;
		newD.amountDebe = Number(d.amountDebe);
		newD.amountHaber = Number(d.amountHaber);
		newD.costCenterId = d.costCenterId ? d.costCenterId : null;
		newD.accountingAccountId = d.accountingAccountId;
		return newD;
	});
	const newData = {
		totalDebe,
		totalHaber,
		details,
	};
	return newData;
}

function validSquareAmounts() {
	let valid = false;
	if (this.rowsDetailModal.length > 0) {
		const debe = this.rowsDetailModal.reduce((sum, item) => sum + item.amountDebe, 0);
		const haber = this.rowsDetailModal.reduce((sum, item) => sum + item.amountHaber, 0);
		valid = debe > haber || debe < haber;
	}
	return valid;
}

function onAddDetail() {
	if (!this.canCreate) return;
	this.openDetailSeat = true;
	this.modelDetail.reference = this.rowsDetailModal.length > 0 ?
		this.rowsDetailModal[0].reference : null;
	this.modelDetail.concept = this.rowsDetailModal.length > 0 ?
		this.rowsDetailModal[0].concept : null;
}

function setData(value) {
	if (this.settings && this.settings.stat && value.stat === 1) {
		this.showNotification('La cuenta no se puede seleccionar', 'warning');
		this.accountingAccount = null;
		this.modelDetail.account = null;
		this.modelDetail.accountingAccountId = null;
	} else {
		this.accountingAccount = { ...value };
		this.modelDetail.account = value.code;
		this.modelDetail.accountingAccountId = value.id;
	}
}

function setModelData({ model, value }) {
	if (model === 'date' || model === 'gloss') {
		this.model[model] = value;
	} else {
		this.modelDetail[model] = value;
	}
}
function setCostCenter(value) {
	this.costCenter = { ...value };
	this.modelDetail.costCenterId = value.id;
}
function typeDetail() {
	return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
}
function validFields() {
	return !this.modelDetail.account || !this.modelDetail.accountingAccountId
	|| !this.modelDetail.amount	|| !this.modelDetail.concept
	|| !this.modelDetail.reference;
}
function validInsertCostCenter() {
	let valid = false;
	if (this.settings.autoCenterCost) {
		const firstDigit = this.modelDetail.account.charAt(0);
		if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
			valid = true;
		}
	}
	return valid;
}
async function saveNewDetailSeat() {
	if (!this.canCreate) return;
	const amount = Number(this.modelDetail.amount);
	const type = amount > 0 ? 'Debe' : 'Haber';
	this.modelDetail.type = amount > 0 ? 1 : 2;
	this.modelDetail.status = 1;
	this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
	const otherType = type === 'Debe' ? 'Haber' : 'Debe';
	this.modelDetail[`amount${otherType}`] = 0;
	this.rowsDetailModal.push({
		...this.modelDetail,
		accountingAccount: this.accountingAccount,
		costCenter: this.costCenter,
		flagEdit: 1,
	});
	this.openDetailSeat = false;
	this.clearModels();
}
function clearModels() {
	this.modelDetail = {
		accountingAccountId: null,
		account: null,
		concept: '',
		reference: '',
		costCenterId: null,
		amount: 0,
	};
}

function validCostCenter() {
	let valid = false;
	if (this.modelDetail.account !== null) {
		const firstDigit = this.modelDetail.account.charAt(0);
		valid = (Number(firstDigit) < 4 && Number(firstDigit) > 8);
	}
	if (valid) {
		this.setCostCenter({});
	}
	return valid;
}

function validateDateRow(row) {
	if (row.moduleId) {
		if (row.moduleId === 3 || row.moduleId === 4) {
			if (row.typeTransactionId === 5 && !row.saleDocumentId) {
				return format(row.emissionDate, 'DD-MM-YYYY');
			}
			if (!row.flagFacWithDocStatus) {
				const paymentDate = row.additionalInformation &&
					row.additionalInformation.paymentDate ?
					row.additionalInformation.paymentDate : row.paymentDate;
				return format(paymentDate, 'DD-MM-YYYY');
			}
			return format(row.createdAt, 'DD-MM-YYYY');
		}
		if (row.moduleId === 8 || row.moduleId === 9) {
			return row.paymentDate && row.paymentDate
				? `<b>F.P: </b> ${format(row.paymentDate, 'DD-MM-YYYY')} <br> <b>F.C: </b>${format(row.createdAt, 'DD-MM-YYYY')}` : format(row.createdAt, 'DD-MM-YYYY');
		}
		return format(row.createdAt || row.dateEnd, 'DD-MM-YYYY');
	} else if (row.moduleCode === 'BANCO' || row.moduleCode === 'CAJA') {
		return row.paymentDate && row.paymentDate
			? `<b>F.P: </b>${format(row.paymentDate, 'DD-MM-YYYY')} <br> <b>F.C: </b>${format(row.createdAt, 'DD-MM-YYYY')}` : format(row.createdAt, 'DD-MM-YYYY');
	}
	return format(row.createdAt || row.dateEnd, 'DD-MM-YYYY');
}

function getAccountItem(account) {
	if (!account) return {};
	return this.accounts.find(acc => acc.id === account.id) || null;
}

function closItemsBlock() {
	this.itemsBlockedPeriod = [];
	this.showItemsBlockAccounting = false;
	this.showItemsBlock = false;
}
function closeDetailDocument() {
	this.showDetails = false;
	this.detailsRegister = null;
}
function getLabelRegister() {
	/* eslint-disable no-nested-ternary */
	const newData = {
		value: null,
		label: '',
	};
	if (this.detailsRegister) {
		if (this.detailsRegister.customerId) {
			const { customer } = this.detailsRegister;
			newData.label = 'Cliente';
			newData.value = customer.rzSocial
				? customer.rzSocial
				: customer.typePerson && customer.typePerson.fullName
					? customer.typePerson.fullName : '';
		} else if (this.detailsRegister.supplierId) {
			const { supplier } = this.detailsRegister;
			newData.label = 'Proveedor';
			newData.value = supplier.name
				? supplier.name : '';
		}
	}
	/* eslint-enable no-nested-ternary */
	return newData;
}

function resultGroups() {
	const groups = RESULT_STAGES.map(stage => ({
		...stage,
		items: this.resultErrors.filter(e => e.stage === stage.stage),
	})).filter(group => group.items.length > 0);

	const knownStages = RESULT_STAGES.map(s => s.stage);
	const others = this.resultErrors.filter(e => knownStages.indexOf(e.stage) === -1);

	if (others.length > 0) {
		groups.push({
			stage: 'otros',
			label: 'Otras novedades',
			hint: 'Revise el detalle de cada registro',
			color: '#78909c',
			items: others,
		});
	}

	return groups;
}
function resetAccountingResult() {
	this.resultErrors = [];
	this.resultSummary = {
		totalReceived: 0,
		totalProcessed: 0,
		totalErrors: 0,
	};
}

/**
 * Lee la respuesta del servicio y acumula summary + errors.
 * Devuelve el resumen SOLO de esta llamada (sirve para el stepper de TODOS).
 */
function collectAccountingResult(response, moduleCode) {
	const empty = { totalReceived: 0, totalProcessed: 0, totalErrors: 0 };

	// Compatibilidad: si el servicio aún devuelve el arreglo plano de siempre.
	if (!response || Array.isArray(response) || typeof response !== 'object') {
		return empty;
	}

	const summary = response.summary || {};
	const errors = Array.isArray(response.errors) ? response.errors : [];

	const current = {
		totalReceived: Number(summary.totalReceived || 0),
		totalProcessed: Number(summary.totalProcessed || 0),
		totalErrors: Number(summary.totalErrors || errors.length),
	};

	this.resultSummary = {
		totalReceived: this.resultSummary.totalReceived + current.totalReceived,
		totalProcessed: this.resultSummary.totalProcessed + current.totalProcessed,
		totalErrors: this.resultSummary.totalErrors + current.totalErrors,
	};

	this.resultErrors = this.resultErrors.concat(
		errors.map(e => ({ ...e, moduleCode: e.moduleCode || moduleCode || null })),
	);

	return current;
}

function errorMessage(item) {
	const messages = {
		SEATS_DUPLICATE: 'El documento ya tiene un asiento contable.',
		SOME_WRONG_ACCOUNTING_SEATS: 'Uno o más detalles no tienen una cuenta contable válida.',
		OUT_OF_SQUQRE_SEATS: 'El asiento está descuadrado.',
		OUT_OF_SQUARE_SEATS: 'El asiento está descuadrado.',
	};

	return messages[item.message] || item.message || 'Novedad sin detalle.';
}

function closeResultModal() {
	this.showResultModal = false;
	this.expandedResult = [];
	this.resetAccountingResult();
}

function copyResultErrors() {
	const lines = this.resultErrors.map(e => [
		e.stage,
		e.moduleCode || '',
		e.documentNumber || e.documentId || '',
		e.code || '',
		e.ruleCode || '',
		this.errorMessage(e),
	].join(' | '));

	const text = `Resultado: ${this.resultSubtitle}\n\n${lines.join('\n')}`;

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(text);
		this.showNotification('Detalle copiado al portapapeles.');
		return;
	}

	const area = document.createElement('textarea');
	area.value = text;
	document.body.appendChild(area);
	area.select();
	document.execCommand('copy');
	document.body.removeChild(area);
	this.showNotification('Detalle copiado al portapapeles.');
}
function resultSubtitle() {
	const { totalReceived, totalProcessed, totalErrors } = this.resultSummary;

	if (!totalErrors) {
		return `${totalProcessed} de ${totalReceived} registros contabilizados.`;
	}

	return `${totalProcessed} de ${totalReceived} registros se contabilizaron. ` +
		`${totalErrors} ${totalErrors === 1 ? 'quedó' : 'quedaron'} con novedad.`;
}
function hasResultDetail(item) {
	return !!(
		(item.details && item.details.length) ||
		(item.invalidAccounts && item.invalidAccounts.length) ||
		(item.document && item.document.id)
	);
}

function toggleResultDetail(key) {
	const index = this.expandedResult.indexOf(key);

	if (index === -1) {
		this.expandedResult.push(key);
	} else {
		this.expandedResult.splice(index, 1);
	}
}

function isResultExpanded(key) {
	return this.expandedResult.indexOf(key) !== -1;
}

/** "Regla VTACRE · campo accountingAccount no resolvió cuenta" */
function ruleAccountHint(line) {
	const rule = line.rule;

	if (!rule) {
		return null;
	}

	const parts = [];

	if (rule.code) {
		parts.push(`Regla <b>${rule.code}</b>`);
	}

	if (!line.accountingAccountId) {
		parts.push(
			rule.accountExpression
				? `la expresión <b>${rule.accountExpression}</b> no resolvió cuenta`
				: 'sin cuenta configurada en la regla',
		);
	} else if (rule.accountingAccountId) {
		parts.push(`cuenta fija id ${rule.accountingAccountId}`);
	} else if (rule.accountExpression) {
		parts.push(`expresión <b>${rule.accountExpression}</b>`);
	}

	return parts.length ? parts.join(' · ') : null;
}

/** "Ref: FAC 001812-78 · fórmula amount" */
function ruleFormulaHint(line) {
	const parts = [];

	if (line.reference) {
		parts.push(`Ref: ${line.reference}`);
	}

	if (line.rule && line.rule.formula) {
		parts.push(`fórmula <b>${line.rule.formula}</b>`);
	}

	if (line.rule && line.rule.terms) {
		parts.push(`condición <b>${line.rule.terms}</b>`);
	}

	return parts.length ? parts.join(' · ') : null;
}

/** Abre tu modal "Detalle Registro" ya existente, sin cerrar el de resultados. */
function goToResultDocument(item) {
	const documentId = item.documentId || (item.document && item.document.id);
	const row = this.rows.find(r => r.id === documentId);

	if (!row) {
		this.showNotification(
			'El documento ya no está en la lista cargada. Vuelva a buscar para verlo.',
			'warning',
		);
		return;
	}

	this.openDetailRegister(row);
}

function copyToClipboard(text) {
	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(text);
		this.showNotification('Copiado al portapapeles.');
		return;
	}

	const area = document.createElement('textarea');
	area.value = text;
	document.body.appendChild(area);
	area.select();
	document.execCommand('copy');
	document.body.removeChild(area);
	this.showNotification('Copiado al portapapeles.');
}

function copyResultItem(item) {
	const lines = (item.details || []).map(line => [
		line.accountCode || line.account || 'SIN CUENTA',
		line.concept || '',
		line.amountDebe || 0,
		line.amountHaber || 0,
		line.rule && line.rule.code ? `regla ${line.rule.code}` : '',
	].join(' | '));

	const text = [
		`Documento: ${item.documentNumber || item.documentId}`,
		`Módulo: ${item.moduleCode || ''} ${item.moduleName || ''}`,
		`Asiento: ${item.code || '-'}`,
		`Novedad: ${this.errorMessage(item)}`,
		'',
		...lines,
	].join('\n');

	this.copyToClipboard(text);
}
function waitDone() {
	return this.newModules.filter((moduleCode) => {
		const status = this.stepStatus[moduleCode];
		return status && status !== 'running';
	}).length;
}

function waitPercent() {
	if (!this.newModules.length) {
		return 0;
	}

	return Math.round((this.waitDone / this.newModules.length) * 100);
}

function waitTitle() {
	return this.flagbtnCloseSeatModal
		? 'Contabilizando registros'
		: 'Proceso terminado';
}
function stepClass(moduleCode) {
	const status = this.stepStatus[moduleCode] || 'pending';
	const index = this.newModules.indexOf(moduleCode);
	const isLast = index === this.newModules.length - 1;

	return {
		'is-pending': status === 'pending',
		'is-running': status === 'running',
		'is-complete': status === 'complete',
		'is-warning': status === 'warning',
		'is-error': status === 'error',
		'is-skipped': status === 'skipped',
		'is-done': status !== 'pending' && status !== 'running' && !isLast,
	};
}

function stepIcon(moduleCode, index) {
	const status = this.stepStatus[moduleCode];

	if (status === 'complete') {
		return '✓';
	}

	if (status === 'warning') {
		return '!';
	}

	if (status === 'error') {
		return '✕';
	}

	if (status === 'skipped') {
		return '–';
	}

	return index + 1;
}

function stepLabel(moduleCode) {
	const labels = {
		running: 'Creando asientos…',
		complete: 'Asientos creados correctamente',
		warning: 'Terminó con novedades',
		error: 'No se pudo contabilizar',
		skipped: 'Sin registros disponibles',
	};

	return labels[this.stepStatus[moduleCode]] || 'En espera';
}

function waitSubtitle() {
	if (!this.flagbtnCloseSeatModal) {
		const withIssues = this.newModules.filter(
			m => this.stepStatus[m] === 'warning' || this.stepStatus[m] === 'error',
		).length;

		return withIssues
			? `${withIssues} ${withIssues === 1 ? 'módulo' : 'módulos'} con novedades`
			: 'Todos los módulos se contabilizaron correctamente';
	}

	const current = this.waitDone + 1;
	const total = this.newModules.length;

	return `Módulo ${current > total ? total : current} de ${total} · no cierre esta ventana`;
}

function data() {
	return {
		deleteTooltip: 'Eliminar Asiento',
		moduleStats: {},
		showResultModal: false,
		expandedResult: [],
		resultErrors: [],
		resultSummary: {
			totalReceived: 0,
			totalProcessed: 0,
			totalErrors: 0,
		},
		currentPage: 1,
		flagNoConfirm: false,
		flagStatusAccounting: false,
		currentPageDetail: 1,
		e13: 1,
		flagWait: false,
		accounts: [],
		costCenters: [],
		rowsIds: [],
		stepStatus: {},
		rowIdsModules: [],
		checkAllAccounting: false,
		checkAll: false,
		columns: [
			{
				id: 1,
				name: 'F. de Crea. / Pago',
				tooltip: 'Fecha de Creación / Pago',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Numero de documento: ',
				value: 'name',
				checked: true,
				visible: true,
			},
			{ id: 3, name: 'Referencia: ', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Módulo: ', checked: true, visible: true, movil: true },
			{ id: 5, name: 'Monto', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Detalle', checked: true, visible: true, movil: true },
		],
		columnsSeat: [
			{
				id: 1,
				name: 'Asiento',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Módulo',
				value: 'module',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Descripción',
				value: 'description',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{ id: 5, name: 'Estado', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Debe', checked: true, visible: true, movil: true },
			{ id: 7, name: 'Haber', checked: true, visible: true, movil: true },
			{ id: 8, name: 'Acción', checked: true, visible: true, movil: true },
		],
		columnsDetail: [
			{
				id: 1,
				name: 'Cód. Cta.',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Cuenta Cta.',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Concepto de mov',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Tipo',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Importe',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 7,
				name: 'Centro de costo',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 8,
				name: 'acciones',
				value: 'actions',
				checked: true,
				visible: true,
			},
		],
		dialogLoading: false,
		itemsTotalQuantity: null,
		itemsTotalQuantityDetails: null,
		dialogDetailAccounting: false,
		dialogAction: false,
		dialogWait: false,
		flagDate: false,
		dataSelectedAccounting: [],
		dataSelected: [],
		dialogDeleteAccounting: false,
		listAccounting: true,
		lastPage: 0,
		lastPageDetails: 0,
		modules: [],
		model: {
			limit: 20,
			search: null,
			moduleId: null,
			stateId: 'pending',
			startDate: null,
			endDate: null,
			onSearch: null,
			status: null,
			typeFac: null,
			accountingSeat: null,
			square: 1,
		},
		mobile: false,
		flagCancel: true,
		nameAccouting: null,
		cancelModal: false,
		showDetailAccounting: false,
		rowsDetails: [],
		rowsDetailModal: [],
		rows: [],
		rowsSeat: [],
		showAccouting: false,
		openMobile: false,
		titleDialogDelete: '',
		rowForDelete: {},
		flagStateRecord: true,
		titleModule: '',
		titleModuleSeat: '',
		valuesShow: {},
		newModules: [],
		detailsRegister: null,
		showDetails: false,
		modulesFilter: [],
		status: [
			// { id: 2, name: 'Anulados' },
			{ id: 3, name: 'Pendientes' },
			{ id: 1, name: 'Contabilizados' },
		],
		statusRecords: [
			{ id: 0, name: 'Sin asiento' },
			// { id: 1, name: 'Con asiento' },
		],
		statusFacs: [
			{ id: 1, name: 'FAC' },
			{ id: 2, name: 'NTV' },
		],
		typesModule: [
			{ id: 1, name: 'Cuadrados' },
			{ id: 2, name: 'No Cuadrados' },
		],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
		subsidiaryId: null,
		loading: false,
		modalWaitSeats: false,
		progress: 0, // Progreso actual (0-100)
		modalDeleteSeat: false,
		seatRowforDelete: {},
		settings: {},
		squareAmounts: false,
		isLoading: false,
		flagValidNumberAccount: false,
		flagValidCostCenter: false,
		flagbtnCloseSeatModal: false,
		dataSeat: {},
		indexRowDetail: null,
		openDetailSeat: false,
		modelDetail: {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		},
		accountingAccount: {},
		costCenter: {},
		flagNewModules: false,
		dataError: [],
		showErrorModal: false,
		transactionBlockingModule: {},
		periodLock: false,
		showItemsBlock: false,
		showItemsBlockAccounting: false,
		itemsBlockedPeriod: [],
	};
}

export default {
	name: 'page-batch-accounting',
	created,
	data,
	destroyed,
	components: {
		actionBar,
		appTooltipButton,
		appDateSelect,
		dateComponent,
		BaseSelect,
		autocompleteComponent,
		appInputText,
		closeIcon,
	},
	computed: {
		permsResource,
		canEdit,
		canDelete,
		canCreate,
		waitDone,
		waitPercent,
		waitTitle,
		waitSubtitle,
		disabledConfirm,
		resultGroups,
		resultSubtitle,
		valuesDisabled,
		...mapGetters('subsidiary', ['currentSubsidiary']),
		verifySubsidiary,
		validateSomeForceInsertCenterCost,
		typeDetail,
		validFields,
		validInsertCostCenter,
		validCostCenter,
		validSquareAmounts,
		accountingAccountItem: {
			get() {
				return this.accounts.find(acc => acc.id === this.modelDetail.accountingAccountId) || null;
			},
			set(val) {
				this.modelDetail.accountingAccountId = val ? val.id : null;
			},
		},
	},
	methods: {
		resetAccountingResult,
		collectAccountingResult,
		stepClass,
		stepIcon,
		stepLabel,
		errorMessage,
		closeResultModal,
		hasResultDetail,
		toggleResultDetail,
		isResultExpanded,
		ruleAccountHint,
		ruleFormulaHint,
		goToResultDocument,
		copyToClipboard,
		copyResultItem,
		copyResultErrors,
		changePage,
		setTypes,
		getDataDate,
		onPage,
		closeDialog,
		clearAccouting,
		setId,
		loadAccounts,
		closeDialogAction,
		closeDetailDocument,
		onDeleteSeat,
		onDeleteSeatMultiple,
		closeDialogAccouting,
		getLabelRegister,
		closeMobile,
		getDate,
		getType,
		loadAccounting,
		loadCont,
		loadModules,
		loadAccountingDetail,
		verifyNewModules,
		statusColor,
		statusColorModules,
		statusNameModules,
		setModule,
		setStatus,
		setStatusFac,
		setStatusRecords,
		openDialogDelete,
		openDetail,
		onSearch,
		rowIsSelected,
		rowIsSelectedAccounting,
		runAction,
		saveAccouting,
		statusName,
		selectedAll,
		selectedAllSeat,
		openDetailRegister,
		postRecord,
		goToEditAccouting,
		reziseMobile,
		openMobileAccouting,
		changeAccount,
		editSeats,
		saveSeat,
		eliminateSeat,
		deleteSeat,
		closeModalDeleteSeat,
		closeModalWaitSeat,
		changeAmountSeat,
		loadCostCenter,
		changeCostCenter,
		setValue,
		refactorizeNumber,
		saveAllDetailsEdits,
		formatData,
		onAddDetail,
		setData,
		setModelData,
		setCostCenter,
		saveNewDetailSeat,
		clearModels,
		validateDateRow,
		closeModalErrorSeat,
		getAccountItem,
		validatePeriodLock,
		closItemsBlock,
		getDateItem,
	},
};
</script>

<style lang="scss" scoped>
.custom-step .v-icon {
  color: white !important; /* Fuerza el color blanco */
}

.tooltip-container {
	position: relative;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	padding: 10px;
	border-radius: 4px;
	width: fit-content;
	height: 20px;
	min-width: 60px; /* Evita que se haga demasiado pequeño */
	font-size: 9px;
	font-family: font(AvenirBold);
}

td {
	text-align: center;
	vertical-align: middle;
}

.btn-accounting {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	font-family: map-get($fonts, AvenirRegular) !important;
	font-size: 12px !important;
	font-weight: 600;
	text-transform: capitalize !important;
	width: 80px;

	@media (max-width: 1024px) {
		width: 100%;
	}
}
.btnSaveAccounting {
	color: white !important;
}
#column-6 {
	span {
		color: red !important;
	}
}

.titleNumberSeat {
	color: #02979b !important;
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-weight: bold;
}
.loading-search {
	color: white !important;
	font-family: map-get($fonts, AvenirDemi) !important;
	font-size: 14px !important;
	text-align: center;
}
.btn-modal {
	border-radius: 30px;
	color: map-get($colors, white);
	height: 30px;
	padding: 0px 20px;
	width: 153px;
}
.content-dialog {
	box-shadow: none !important;
}

.blue-debe {
	color: #006edb;
	font-family: map-get($fonts, AvenirBold);
	padding: 0 5px;
}
[data-tooltip] {
	position: relative;
	cursor: pointer;
}

[data-tooltip]:hover::before {
	content: attr(data-tooltip);
	position: absolute;
	top: -25px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #1fd9b6;
	color: #fff;
	padding: 4px 8px;
	border-radius: 4px;
	white-space: nowrap;
	z-index: 999;
	font-size: 11px;
	font-family: 'Avenir Regular', sans-serif;
}

.tooltip-zero[data-tooltip]:hover::before {
	background-color: red !important; /* Fondo rojo para el tooltip de valor 0 */
}
.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}
.red-haber {
	color: #ff0000;
	font-family: map-get($fonts, AvenirBold);
	text-align: end;
	padding: 0 5px;
}

.btn {
	border-radius: 30px;
	color: white;
	height: 30px;
	padding: 0 10px;
	width: 90px;
}

.agree {
	background-color: color(secondary);
	margin-left: 10px;
}

.cancel {
	background-color: color(error);
	margin-right: 10px;
}
.cancelSeat {
	background-color: color(error);
}
.save {
	background-color: color(secondary);
}

.show-mobile {
	@media (max-width: 890px) {
		padding: 8px !important;
	}
}

.row-mobile {
	@media (min-width: 1024px) {
		padding: 0 24px;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/8;
		grid-row: 2;
		white-space: nowrap;
	}
}

.reference {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}

.entity {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.content-acc {
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all 0.2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
			width: 100%;
		}
	}
}

.horizontal-buttons {
  overflow-x: auto; /* Permite el desplazamiento horizontal si los elementos no caben */
  white-space: nowrap; /* Evita que los elementos se envuelvan */
}

.horizontal-buttons .v-flex {
  display: inline-block; /* Muestra los elementos en línea */
  margin-right: 8px; /* Espacio entre los elementos */
}

.horizontal-buttons .v-flex:last-child {
  margin-right: 0; /* Elimina el margen del último elemento */
}

.loading-icon {
	display: inline-flex;
	align-items: center;
}

.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-top: 4px solid #3d989b;
	border-radius: 100%;
	width: 60px;
	height: 40px;
	margin: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.titleWait {
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-size: 20px;
	font-weight: bold;
	display: inline-block;
	margin: 0;
}
.text-card {
	border-radius: 10px;
	background-color: #e6e2e2;
}

.btn-edit-detail {
	background-color: color(secondary);
	border-radius: 10px;
	color: color(white);
	font-family: font(AvenirBold);
	font-size: size(small11);
	padding: 2px 4px 0px;
}
.wrapper-text {
	left: 57px;
	position: absolute;
	top: 10px;
}
.border-radius {
	border-radius: 50%;
	height: 23px;
	width: 23px;
}

.card-container-blocked {
	border-radius: 8px;
	background-color: white;
	&-text {
		padding: 1rem;
		display: flex;
		flex-direction: column;
		&-title {
			color: color(grey-icon);
			font-size:size(medium16);
			font-weight: 500;
		}
		&-list {
			display: flex;
			flex-direction: column;
			max-height: 350px;
			overflow-y: auto;
			scroll-behavior: smooth;
		}
	}
	&-actions {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 1rem;
		padding: 1rem;
		border-top: 1px solid color(gray-light);
	}
}

.card {
	background: #bbd6f1;
	border: 1px solid #8abaeb;
	border-radius: 8px;
	padding: 1rem;
	margin-bottom: 12px;

	/* Sombra sutil */
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

	/* Transiciones */
	transition: all 0.2s ease;

	/* Animación de entrada */
	animation: cardFadeIn 0.3s ease-out;
}

/* Última tarjeta sin margen inferior */
.card:last-child {
	margin-bottom: 0;
}

@keyframes cardFadeIn {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* Hover en tarjeta */
.card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
	border-color: #dee2e6;
}

.card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.card-title {
	font-size: size(medium);
	font-weight: 500;
	color: color(grey-text);
	margin: 0;
	line-height: 1.4;
}

.card-body {
	margin-bottom: 0;
	display: flex;
	flex-direction: column;
}

.card-description {
	font-size: size(small);
	color: color(grey-text);
}
.card-container-details {
	display: flex;
	flex-direction: column;
	padding: 5px;
	border-radius: 8px;
	background-color: white;
	&-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 4px;
	}
	&-list {
		padding: 4px;
	}
}
.content-green {
	background: color(title-green);
	color: color(background-sidebar);
	font-family: font(open-bold);
	font-size: size(small11);
	min-width: 125px;
	padding: 4px 12px;
}

.c-text-green {
	background: color(text-green);
	color: color(paginationText);
	font-family: font(open-regular);
	font-size: size(small11);
	padding: 4px 12px;
	width: calc(100% - 125px);
}
/* ===== MODAL RESULTADO DE LA CONTABILIZACIÓN ===== */
.result-modal {
	background: #fff;
	border-radius: 10px;

	&__header {
		align-items: flex-start;
		border-bottom: 1px solid #eceff1;
		display: flex;
		justify-content: space-between;
		padding: 16px 20px 12px;
	}

	&__title {
		color: #37474f;
		display: block;
		font-family: 'Avenir Regular', Arial, sans-serif;
		font-size: 17px;
		font-weight: 700;
	}

	&__subtitle {
		color: #78909c;
		display: block;
		font-size: 12px;
		margin-top: 3px;
	}

	&__stats {
		background: #f7f9fa;
		display: flex;
		padding: 14px 20px;
	}

	&__stat {
		background: #fff;
		border: 1px solid #e3e8ea;
		border-radius: 8px;
		flex: 1;
		margin-right: 10px;
		padding: 10px 6px;
		text-align: center;

		&:last-child {
			margin-right: 0;
		}

		&.is-ok .result-modal__stat-value {
			color: #1fd9b6;
		}

		&.is-error .result-modal__stat-value {
			color: #e53935;
		}
	}

	&__stat-value {
		color: #455a64;
		display: block;
		font-size: 22px;
		font-weight: 700;
		line-height: 1;
	}

	&__stat-label {
		color: #90a4ae;
		display: block;
		font-size: 10px;
		letter-spacing: 0.4px;
		margin-top: 5px;
		text-transform: uppercase;
	}

	&__body {
		max-height: 430px;
		overflow-y: auto;
		padding: 16px 20px !important;
	}

	&__empty {
		padding: 26px 0;
		text-align: center;

		p {
			color: #607d8b;
			font-size: 13px;
			margin: 10px 0 0;
		}
	}

	&__actions {
		background: #fafbfc;
		border-top: 1px solid #eceff1;
		display: flex;
		justify-content: flex-end;
		padding: 12px 20px;
	}
}

.result-group {
	margin-bottom: 18px;

	&__header {
		align-items: center;
		border-left: 4px solid #ccc;
		display: flex;
		margin-bottom: 9px;
		padding: 3px 0 3px 10px;
	}

	&__badge {
		align-items: center;
		border-radius: 12px;
		color: #fff;
		display: inline-flex;
		font-size: 12px;
		font-weight: 700;
		height: 24px;
		justify-content: center;
		margin-right: 10px;
		min-width: 24px;
		padding: 0 7px;
	}

	&__title {
		color: #37474f;
		display: block;
		font-size: 14px;
		font-weight: 700;
	}

	&__hint {
		color: #90a4ae;
		display: block;
		font-size: 11px;
	}
}

.result-item {
	background: #fff;
	border: 1px solid #e3e8ea;
	border-radius: 8px;
	margin-bottom: 8px;
	padding: 10px 12px;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
	}

	&__head {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	&__doc {
		color: #263238;
		font-size: 13px;
		font-weight: 700;
	}

	&__date {
		color: #90a4ae;
		font-size: 11px;
	}

	&__gloss {
		color: #546e7a;
		font-size: 12px;
		margin: 4px 0 0;
	}

	&__message {
		color: #c62828;
		font-size: 12px;
		margin: 5px 0 0;
	}

	&__accounts {
		margin-top: 4px;
	}

	&__accounts-title {
		color: #78909c;
		font-size: 11px;
		margin-right: 4px;
	}
}

.result-tag {
	background: #eceff1;
	border-radius: 10px;
	color: #546e7a;
	display: inline-block;
	font-size: 10px;
	margin: 7px 6px 0 0;
	padding: 2px 9px;

	&.is-module {
		background: #e0f2f1;
		color: #00796b;
		font-weight: 700;
	}

	&.is-debe {
		background: #e3f0ff;
		color: #006edb;
	}

	&.is-haber {
		background: #ffe8e8;
		color: #d32f2f;
	}

	&.is-diff {
		background: #fff4d6;
		color: #a9731a;
	}

	&.is-account {
		background: #f3e5f5;
		color: #7b1fa2;
	}
}

.result-item__toggle {
	color: #02979b;
	cursor: pointer;
	display: inline-block;
	font-size: 11px;
	font-weight: 700;
	margin-top: 8px;
}

.result-sub {
	border-top: 1px dashed #e3e8ea;
	margin-top: 10px;
	padding-top: 8px;

	&__title {
		color: #90a4ae;
		display: block;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: 0.5px;
		margin-bottom: 6px;
		text-transform: uppercase;
	}
}

.result-doc {
	display: flex;
	flex-wrap: wrap;

	&__field {
		color: #455a64;
		font-size: 11px;
		margin-bottom: 4px;
		width: 50%;
	}

	&__label {
		color: #90a4ae;
	}
}

.result-lines {
	border-collapse: collapse;
	width: 100%;

	th {
		border-bottom: 1px solid #eceff1;
		color: #90a4ae;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: 0.3px;
		padding: 3px 6px;
		text-align: left;
		text-transform: uppercase;
	}

	td {
		border-bottom: 1px solid #f4f6f7;
		color: #455a64;
		font-size: 11px;
		padding: 6px;
		vertical-align: top;
	}

	tr.is-invalid {
		background: #fff5f5;
	}

	.num {
		text-align: right;
		white-space: nowrap;
	}
}

.result-line__account-empty {
	color: #c62828;
	font-style: italic;
	font-weight: 700;
}

.result-line__name {
	color: #78909c;
	display: block;
	font-size: 10px;
}

.result-line__rule {
	color: #90a4ae;
	display: block;
	font-size: 9px;
	margin-top: 3px;

	b {
		color: #7b1fa2;
	}
}

.result-actions {
	margin-top: 10px;
}

.btn-mini {
	background: #fff;
	border: 1px solid #cfd8dc;
	border-radius: 14px;
	color: #546e7a;
	cursor: pointer;
	font-size: 10px;
	margin-right: 6px;
	padding: 4px 11px;

	&.is-primary {
		border-color: #02979b;
		color: #02979b;
	}
}

.result-ghost {
	background-color: #90a4ae;
	margin-right: 10px;
}
/// progress bar
/* ===== MODAL DE PROGRESO POR MÓDULO ===== */
.wait-modal {
	background: #fff;
	border-radius: 12px;

	&__header {
		border-bottom: 1px solid #eceff1;
		padding: 18px 22px 14px;
	}

	&__title {
		color: #37474f;
		display: block;
		font-size: 16px;
		font-weight: 700;
	}

	&__subtitle {
		color: #90a4ae;
		display: block;
		font-size: 11px;
		margin-top: 3px;
	}

	&__progress {
		padding: 14px 22px 6px;
	}

	&__actions {
		display: flex;
		justify-content: flex-end;
		padding: 12px 22px 16px;
	}
}

.wait-steps {
	padding: 6px 22px 2px;
}

.wait-step {
	align-items: flex-start;
	display: flex;
	padding: 11px 0;
	position: relative;

	&:not(:last-child)::before {
		background: #eceff1;
		bottom: -3px;
		content: '';
		left: 13px;
		position: absolute;
		top: 34px;
		width: 2px;
	}

	&.is-done:not(:last-child)::before {
		background: #b2dfdb;
	}

	&__icon {
		align-items: center;
		background: #cfd8dc;
		border-radius: 50%;
		color: #fff;
		display: flex;
		flex: 0 0 28px;
		font-size: 12px;
		font-weight: 700;
		height: 28px;
		justify-content: center;
		margin-right: 12px;
		width: 28px;
		z-index: 1;
	}

	&__spinner {
		animation: waitspin 0.7s linear infinite;
		border: 2px solid rgba(255, 255, 255, 0.35);
		border-radius: 50%;
		border-top-color: #fff;
		height: 13px;
		width: 13px;
	}

	&__body {
		flex: 1;
		padding-top: 2px;
	}

	&__name {
		color: #37474f;
		display: block;
		font-size: 13px;
		font-weight: 700;
		letter-spacing: 0.2px;
	}

	&__status {
		color: #90a4ae;
		display: block;
		font-size: 11px;
		margin-top: 2px;
	}

	&__counts {
		margin-top: 5px;
	}

	&.is-pending {
		.wait-step__icon {
			background: #fff;
			border: 2px solid #cfd8dc;
			color: #b0bec5;
		}

		.wait-step__name {
			color: #b0bec5;
		}
	}

	&.is-running .wait-step__icon {
		background: #02979b;
	}

	&.is-complete .wait-step__icon {
		background: #1fd9b6;
	}

	&.is-warning {
		.wait-step__icon {
			background: #f5a623;
		}

		.wait-step__status {
			color: #b77b11;
		}
	}

	&.is-error {
		.wait-step__icon {
			background: #e53935;
		}

		.wait-step__status {
			color: #e53935;
		}
	}

	&.is-skipped .wait-step__icon {
		background: #b0bec5;
	}
}

@keyframes waitspin {
	to {
		transform: rotate(360deg);
	}
}

.wait-chip {
	border-radius: 9px;
	display: inline-block;
	font-size: 9px;
	margin-right: 5px;
	padding: 2px 8px;

	&.is-ok {
		background: #e0f7f3;
		color: #00897b;
	}

	&.is-bad {
		background: #ffeaea;
		color: #d32f2f;
	}
}

.wait-progress {
	background: #eceff1;
	border-radius: 10px;
	height: 6px;
	overflow: hidden;

	&__bar {
		background: linear-gradient(90deg, #02979b, #1fd9b6);
		border-radius: 10px;
		height: 100%;
		transition: width 0.45s ease;
	}

	&__labels {
		display: flex;
		justify-content: space-between;
		margin-top: 6px;
	}

	&__text {
		color: #90a4ae;
		font-size: 10px;
	}

	&__pct {
		color: #02979b;
		font-size: 10px;
		font-weight: 700;
	}
}

.wait-btn {
	background: #02979b;
	border: 0;
	border-radius: 30px;
	color: #fff;
	cursor: pointer;
	font-size: 12px;
	height: 32px;
	padding: 0 22px;

	&[disabled] {
		background: #cfd8dc;
		cursor: default;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-batch-accounting.vue